// @ts-strict-ignore
/**
 * Created by vwiny on 10/10/2017.
 */
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewContainerRef,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LMRouteComponentService } from '@services/lm-route-component.service';
import { LMFormRequestService } from '@form/services/lm-form-request.service';
import {
  SohoAccordionComponent,
  SohoAlertDirective,
  SohoAutoCompleteComponent,
  SohoBusyIndicatorDirective,
  SohoDataGridComponent,
  SohoDropDownComponent,
  SohoLookupComponent,
  SohoMessageService,
  SohoModalDialogRef,
  SohoModalDialogService,
  SohoSpinboxComponent,
  SohoTabsComponent,
  SohoTrackDirtyDirective
} from 'ids-enterprise-ng';
import {
  LMReportPersonalizationDialogResult,
  LMReportPersonalizationDialogResultCode,
  LMReportPersonalizationDialogService
} from './lm-report-personalization-dialog.service';
import { AppConstants, FilterBuilderDialogResult, LMDialogButtonKey } from '@utils/app.constants';
import { LMLoggerService } from '@services/lm-logger.service';
import { LMHtmlPageUtilService } from '@html/lm-html-page-util.service';
import { ReportPersonalizationSwapListService } from './lm-report-personalization-swaplist-service';
import { LMLookupDialogComponent } from '@field/lookup/lm-lookup-dialog.component';
import { LMLookupSelectionEvent } from '@field/lookup';
import { LMSpecService } from '@services/lm-spec.service';
import { ConfirmationDialogResult, LMConfirmationMessageService } from '@modal/lm-confirmation-message.service';
import { LMErrorUtilService } from '@services/utils/lm-error-util.service';
import { LMUrlUtilService } from '@services/utils/lm-url-util.service';
import { LMConfigurationService } from '@services/lm-configuration.service';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, first, flatMap, switchMap, takeUntil, takeWhile } from 'rxjs/operators';
import { LMFormatUtilService } from '@services/utils/lm-format-util.service';
import { LMCommonUtilService, LMUniqueIdService } from '../../../utils';
import { LMFilterBuilderService } from '@modal/filter-builder/services/lm-filter-builder.service';
import { LMContextService } from '@services/lm-context.service';
import { LMFieldPickerService } from '@modal/field-picker/services';
import { LMFieldValidatorService } from '@modal/lm-field-validator.service';
import { LMComputeBuilderService } from '@modal/compute-builder/services';
import { LMCubeDimensionsDialogComponent } from '@modal/cubes/lm-cube-dimensions-dialog.component';
import { LMSelectDialogService, LMSelectResponse } from '@app/components';
import {
  LMFieldPickerOperatorOptions,
  LMFieldPickerResponse,
  LMFieldPickerSelectOptions,
  LMFieldPickerSelectResponse
} from '@modal/field-picker/lm-field-picker';
import { DomSanitizer } from '@angular/platform-browser';
import { LMReportsCatalogService } from '../catalog/lm-reports-catalog.service';
import { LMReportsCatalogStateService } from '@app/states/services/lm-reports-catalog-state.service';
import { LMCreateReportDialogService } from '@report/index';
import { LMValidateFieldResponse } from '@app/components/modal/lm-field-editor-dialog';
import * as DOMPurify from 'dompurify';

enum FieldAlertType {
  RED_ALERT			= 1,
  YELLOW_ALERT		= 2,
  GREEN_ALERT		= 3,
  BLUE_ALERT	    = 4,
  ICON_ALERT	    = 5
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
const customAlertFormatter = function(row, cell, value, col, item, api) {
  if (value !== '') {
    if (item.type !== FieldAlertType.ICON_ALERT) {
      const content = `<svg style="visibility: visible" class="icon datagrid-alert-icon icon-${item.iconImage}" role="presentation">` +
          `<use xlink:href="#icon-${item.iconImage}"></use></svg>`;
      return Soho.Formatters.Input(row, cell, content, col, item, api);
    } else {
      const content = `<img src="` + item.iconImage +
          `" style="height: 15px; margin-right: 5px; position: relative;" role="presentation">`;
      return Soho.Formatters.Input(row, cell, content, col, item, api);
    }
  } else {
    return Soho.Formatters.Input(row, cell, value, col, item, api);
  }
};

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
const customAlertConditionFormatter = function(row, cell, value, col, item, api) {
  if (value !== '' && item.negated) {
    let condition: string = value;
    condition = condition.replace('not', '').trim();
    return Soho.Formatters.Input(row, cell, condition, col, item, api);
  } else {
    return Soho.Formatters.Input(row, cell, value, col, item, api);
  }
};

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
const customFormatter = function(row, cell, value, col, item, api) {
  let content = '';
  let columnLabel = '';

  if (col.field === 'label') {
    columnLabel = item.label ? item.label : item.placeholder;

    if (!columnLabel){
      if (item.name !== undefined) {
        columnLabel = item.name.replace(/([a-z])([A-Z])/g, '$1 $2');
        columnLabel = columnLabel.replace(/([A-Z])([A-Z][a-z])/g, '$1 $2');
      }
      content += '<p class="datagrid-row-heading" style="font-style: italic;">' + columnLabel + '</p>';
    } else {
      content += '<p class="datagrid-row-heading">' + columnLabel + '</p>';
    }
  } else if (col.field === 'field') {
    columnLabel = item.name;
    content += '<p class="datagrid-row-heading">' + columnLabel + '</p>';
  }

  if (item.defaultSort) {
    content = '<div style="display: flex;flex-direction: row;flex-wrap: wrap;">' + content;
    content += '<div style="flex-grow: 1;margin-left: 5px;margin-top: 1px;"><span class="tag lm-font-md">' + Soho.Locale.translate('ListPersonalizationDefaultSortLabel40') + '</span></div>';
    content += ' </div>';
  }

  return Soho.Formatters.Input(row, cell, content, col, item, api);
};

@Component({
  selector: 'lm-create-report',
  templateUrl: './lm-report-personalization-dialog.component.html',
  styleUrls: [ 'lm-report-personalization-dialog.component.scss' ],
  providers: [
  LMRouteComponentService, LMFormRequestService, LMHtmlPageUtilService, ReportPersonalizationSwapListService,
  LMFieldValidatorService,
  LMReportsCatalogStateService
    // LMFieldEditorDialogService,
    // LMComputeEditorDialogService
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
  })

export class LMReportPersonalizationDialogComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('columnDataGridComponent') columnDataGridComponent: SohoDataGridComponent;
  @ViewChild('alertDataGridComponent') alertDataGridComponent: SohoDataGridComponent;
  @ViewChild(SohoSpinboxComponent) spinboxComponent: SohoSpinboxComponent;
  @ViewChild(SohoBusyIndicatorDirective) busyIndicator: SohoBusyIndicatorDirective;
  @ViewChild(SohoLookupComponent) sohoLookup: SohoLookupComponent;
  @ViewChild(SohoAccordionComponent) accordionComponent: SohoAccordionComponent;
  @ViewChildren(SohoAlertDirective) alerts: QueryList<SohoAlertDirective>;
  @ViewChild(SohoTrackDirtyDirective) trackDirty: SohoTrackDirtyDirective;
  @ViewChild('sortOrder', { static: false }) dropDown: SohoDropDownComponent;
  @ViewChild('fieldName', { static: false }) fieldNameComponent: SohoAutoCompleteComponent;
  @ViewChild('modalPlaceholder', { read: ViewContainerRef }) modalPlaceholder: ViewContainerRef;
  @ViewChild(LMCubeDimensionsDialogComponent) cubeDimensions: LMCubeDimensionsDialogComponent;
  @ViewChild(SohoTabsComponent) tabs: SohoTabsComponent;

  @ViewChild(SohoAlertDirective) fieldAlert: SohoAlertDirective;
  @Input() mode: LMReportPersonalizationMode;
  @Input() personalizationExists: boolean;
  @Input() url: string;
  @Input() actorGroupUrl: string;
  @Input() roleUrl: string;
  @Input() roleGroupUrl: string;
  @Input() fieldSearchUrl: string;
  @Input() contained: boolean;
  @Input() listTitle: string;
  @Input() listUrlInfo: LMListUrlInfo;
  @Input() listSpec: LMListSpec;
  @Input() dataViewSet: LMDataViewSet;
  @Input() cubeViewState: LMListState;
  @Input() includeBaseFilter: boolean;
  @Input() createReportMode: boolean;

  @Input() businessClass: string;
  @Input() listName: string;
  @Input() userFolderId: string;
  @Input() selectedFields: LMPersonalizationColumn[];
  @Input() reportName: string;
  @Input() reportType: LMReportType;

  @Input() filterCondition: string;
  @Input() chartName: string;
  @Input() dialog$: Subject<LMReportPersonalizationDialogResult>;

  private MATCH_OPTION_ALL = 'all';

  private PRIVATE_SHARING_OPTION = 'Private';
  private PUBLIC_SHARING_OPTION = 'Public';
  private GROUP_SHARING_OPTION = 'Group';
  private ROLE_SHARING_OPTION = 'Role';
  private ROLEGROUP_SHARING_OPTION = 'RoleGroup';

  private REPORT_NAME_FIELD = 'ReportName';
  private LIST_NAME_FIELD = 'ListName';
  private ACTOR_GROUP_FIELD = 'ActorGroup';
  private ROLE_FIELD = 'Role';
  private ROLE_GROUP_FIELD = 'RoleGroup';
  private SHARED_WITH_OPTION_FIELD = 'SharedWithOption';
  private BUSINESS_CLASS_FIELD = 'BusinessClass';
  private PDF_OFFSET_FIELD = 'FontOffsetSpinner';
  private PDF_ORIENTATION_FIELD = 'Orientation';
  private CHART_NAME_FIELD = 'ChartName';
  private DATA_OPTION_FIELD = 'DataOption';
  private AS_OF_DATE_FIELD = 'AsOfDate';
  private FROM_SCRATCH_FIELD = 'FromScratch';

  listUrl: string;
  filterMode: string;
  disableEdit: boolean;
  disableRemove: boolean;
  disableAsOfDate: boolean;
  separator: string;
  canTotal: boolean;
  sharing: any[];
  listNames: any[];
  // listName: string;
  busClassName: string;
  businessClasses: any[];
  viewNames: any[];
  allViewNames: { [key: string]: any[] } = {};
  sortColumns: any[];
  isPrimaryList: boolean;
  noChartView: boolean;
  conditionValid: boolean;
  originalTitle: string;
  isColumnarView: boolean;
  sortOrders: any[];
  totaling: Array<TotalOption> = [];
  public noRedAlert: boolean;
  public noGreenAlert: boolean;
  public noYellowAlert: boolean;
  public noBlueAlert: boolean;
  public hasAllAlerts: boolean;
  public selectedField: LMPersonalizationColumn;
  editOperatorLabel = Soho.Locale.translate('FieldPicker_EditOperatorLink');
  alertOptions: LMFieldEditorFieldAlert[];
  iconAlert: string;
  // fieldAlert: SohoAlertDirective;
  computeAlert: SohoAlertDirective;
  conditionAlert: SohoAlertDirective;
  disableTabs: boolean;

  private availableItems$ = new BehaviorSubject([]);
  public availableItems = this.availableItems$.asObservable();

  private selectedItems$ = new BehaviorSubject([]);
  public selectedItems = this.selectedItems$.asObservable();

  private lookupSelectionEvent: LMLookupSelectionEvent;
  private lookupSelectionSubscription;
  private unsubscribe$ = new Subject<void>();

  private fieldValidation$ = new Subject<string>();

  private static readonly generalCategory = { value: '', label: 'General', selected: true }; //dpb

  public appReport: LMAppReport = {
    modules: [],
    webApps: [],
    categories: [],
    category: null,
    module: null,
    selectedWebApps: [],
    description: undefined
  };
  public isApplicationReport = false;
  public isCategoryLiteral = false;
  public instanceSelectionValidator$ = new Subject<LMLplValidationResponse>();
  private reportUrl: string;
  private actorGroupSelectUrl: string;
  private roleSelectUrl: string;
  private roleGroupSelectUrl: string;
  public displayFields: Array<LMPersonalizationColumn>;
  public setSpecs: { [key: string]: LMSetSpec };
  private shareLookupDialog: SohoModalDialogRef<any>;
  private fieldLookUpUrl: string;
  public allowSharing = true;
  public conditionNames: Array<ConditionName>;
  public selectedAlert: number;
  public isCubeView = false;
  public cubeParent: string;
  // public cubeViewState: LMListState;
  private cubeColumnView: string;
  public testVersion3: boolean;
  public showLabelText: string;
  public showLabel: boolean;
  public filterConditionInitial: string;
  public filterConditionChanged: boolean;
  public allowSharingDropdownAttributes = [ { name: 'data-automation-id', value: 'lm-personalization-sharing' } ];
  public fieldSortOrderDropdownAttributes = [ { name: 'data-automation-id', value: 'lm-personalization-field-sort-order' } ];
  public fieldTotalingDropdownAttributes =  [ { name: 'data-automation-id', value: 'lm-personalization-field-totaling' } ];
  public fieldDataGridAttributes = [ { name: 'data-automation-id', value: 'lm-personalization-field-list-datagrid' } ];
  public fieldAlertDataGridAttributes = [ { name: 'data-automation-id', value: 'lm-personalization-field-alert-list-datagrid' } ];
  public computeTotalingDropdownAttributes = [ { name: 'data-automation-id', value: 'lm-personalization-compute-totaling' } ];
  public customFontOffsetSpinboxAttributes = [ { name: 'data-automation-id', value: 'lm-personalization-pdf-font-offset' } ];
  public customFontOffsetSpinBoxDataOptions = JSON.stringify({ min: -5, max: 20, attributes: this.customFontOffsetSpinboxAttributes });

  columnGridOptions: SohoDataGridOptions;
  alertGridOptions: SohoDataGridOptions;

  sortByInfo: Array<LMSortInfo>;
  subTotalByInfo: Array<LMSubTotalByInfo>;
  subtotalOverride: Array<LMSubtotalOverride>;
  showTotalsOnly: boolean;
  suppressSubtotals: boolean;
  hasTotaling: boolean;
  columnTotalFieldInfo: Array<LMTotalFieldInfo>;
  summaryTotalFields: Array<LMSummaryTotalField>;
  summaryTotalFieldInfo: Array<LMTotalFieldInfo>;
  sortByHeaderTitle: string;
  sortByHelpText: string;
  subtotalByHeaderTitle: string;
  subtotalByHelpText: string;
  totalFieldsHeaderTitle: string;
  totalFieldsHelpText: string;
  columnTotalWidgetTitle: string;
  columnTotalHelpText: string;
  addColumnCountButtonText: string;
  emptyMessageColumnTotalFields: string;
  summaryTotalWidgetTitle: string;
  summaryTotalHelpText: string;
  addSummaryTotalFieldButtonText: string;
  emptyMessageSummaryTotalFields: string;
  isNewField = false;
  isEditing = false;
  enableOperator = false;


  public model: LMListPersonalizationInfo = {
    name: '',
    conditionString: '',
    baseFilter: '',
    includeBaseFilter: false,
    dataOption: 'live',
    sharing: '',
    businessClass: '',
    listName: '',
    viewName: '',
    actorGroup: '',
    role: '',
    roleGroup: '',
    fontOffset: 0,
    fontOffsetOption: '',
    showLines: 0,
    showGridLines: false,
    suppressHeader: false,
    suppressFooter: false,
    orientation: 'landscape',
    asOfDate: '',
    actualOrRound: '',
    roundingPrecision: false,
    displayNegInParens: false,
    defaultSortColumn: '',
    sortDescending: false,
    titleChanged: false,
    fieldLookupUrl: '',
    category: '',
    module: '',
    description: '',
    isReport: false,
  };

  private confirmedMessageIds: string[];

  protected dialog: SohoModalDialogRef<any>;

  public pickerOptions: SohoDatePickerOptions = {
    mode: 'standard',
    dateFormat: Soho.Locale.calendar().dateFormat.short,
    showMonthYearPicker: true
  };

  public get enableDefaultSort(): boolean {
    if (this.model.defaultSortColumn === undefined || this.model.defaultSortColumn === '') {
      return true;
    } else {
      if (this.selectedField.sortOrder !== this.model.defaultSortColumn) {
        return false;
      } else {
        return true;
      }
    }
  }

  public get dataView(): LMReportPersonalizationDataView {
    const fields = {};
    fields[this.REPORT_NAME_FIELD] = this.model.name;
    fields[this.LIST_NAME_FIELD] = this.model.listName;
    fields[this.ACTOR_GROUP_FIELD] = this.model.actorGroup;
    fields[this.ROLE_FIELD] = this.model.role;
    fields[this.ROLE_GROUP_FIELD] = this.model.roleGroup;
    fields[this.SHARED_WITH_OPTION_FIELD] = this.model.sharing;
    fields[this.BUSINESS_CLASS_FIELD] = this.model.businessClass;
    fields[this.PDF_OFFSET_FIELD] = this.model.fontOffset;
    fields[this.PDF_ORIENTATION_FIELD] = this.model.orientation;
    fields[this.CHART_NAME_FIELD] = this.model.viewName;
    fields[this.DATA_OPTION_FIELD] = this.model.dataOption;
    fields[this.AS_OF_DATE_FIELD] = this.lmFormatUtilService.yyyymmddToData(this.model.asOfDate);
    if ('ReportFromScratch' === this.reportType)
      fields[this.FROM_SCRATCH_FIELD] = true;

    let reportDataView: LMReportPersonalizationDataView = {
      fields,
      listTitle: this.model.name,
      defaultSortField: this.model.defaultSortColumn,
      sortDescending: this.model.sortDescending,
      manualCondition: this.model.conditionString,
      includeBaseFilter: this.model.includeBaseFilter,
      titleChanged: this.model.titleChanged,
      confirmedMessageIds: this.confirmedMessageIds,
      showTotalsOnly: this.showTotalsOnly,
      suppressSubTotals: this.suppressSubtotals,
      subtotalOverride: this.subtotalOverride,
      summaryTotalFields: this.summaryTotalFields,
      showGridLines: this.model.showGridLines,
      showLines: this.model.showLines,
      suppressHeader: this.model.suppressHeader,
      suppressFooter: this.model.suppressFooter
    };

    const applicationReport = {
      category: this.model.category,
      module: this.model.module,
      description: this.model.description
    };

    if (this.isApplicationReport) {
      reportDataView.isReport = true;
      reportDataView = { ...reportDataView, ...applicationReport };
    }

    return reportDataView;
  }

  get actorGroupSharing(): boolean {
    return this.model.sharing === 'Group';
  }

  get roleSharing(): boolean {
    return this.model.sharing === 'Role';
  }

  get roleGroupSharing(): boolean {
    return this.model.sharing === 'RoleGroup';
  }

  public emptyMessage: SohoEmptyMessageOptions = {
    title: Soho.Locale.translate('ListPersonalizationNoFieldAlertsMessage'),
    icon: 'icon-empty-no-alerts-new',
  };

  constructor(private ngZone: NgZone,
    private http: HttpClient,
    private element: ElementRef,
    private changeDetectionRef: ChangeDetectorRef,
    private domSanitizer: DomSanitizer,
    private lmContextService: LMContextService,
    private lmFormRequestService: LMFormRequestService,
    private lmSpecService: LMSpecService,
    private lmLoggerService: LMLoggerService,
    private lmHtmlPageUtilService: LMHtmlPageUtilService,
    private lmErrorUtilService: LMErrorUtilService,
    private lmFieldValidatorService: LMFieldValidatorService,
    private lmConfirmationMessageService: LMConfirmationMessageService,
    private lmUrlUtilService: LMUrlUtilService,
    private swapListService: ReportPersonalizationSwapListService,
    private sohoModalDialogService: SohoModalDialogService,
    private lmFormatUtilService: LMFormatUtilService,
    private lmUniqueIdService: LMUniqueIdService,
    private lmFilterBuilderService: LMFilterBuilderService,
    private lmFieldPickerService: LMFieldPickerService,
    private lmComputeBuilderService: LMComputeBuilderService,
    private lmCommonUtilService: LMCommonUtilService,
    private lmConfigurationService: LMConfigurationService,
    private lmSelectDialogService: LMSelectDialogService,
    private lmReportPersonalizationDialogService: LMReportPersonalizationDialogService,
    private lmReportsCatalogService: LMReportsCatalogService,
    private lmReportsCatalogStateService: LMReportsCatalogStateService,
    private lmCreateReportDialogService: LMCreateReportDialogService,
    private sohoMessageService: SohoMessageService) {
    // no-op
  }

  autoCompleteSource = ((searchTerm: string, response: SohoAutoCompleteResponseFunction) => {
    const url = this.listUrlInfo ? this.listUrlInfo.fieldSearchUrl : this.fieldSearchUrl;
    const mode = this.isCubeView ? 'Measures' : 'Fields';
    this.lmConfigurationService.searchField(searchTerm, url, this.model.businessClass, mode)
      .subscribe((fieldPickerResponse: LMFieldPickerResponse) => {
        let uiFieldSpecNames: Array<string>;
        if (fieldPickerResponse.data) {
          uiFieldSpecNames = fieldPickerResponse.data.map(uiFieldSpec => this.lmFieldPickerService.getUIFieldSpecSearchName(uiFieldSpec));
          response(searchTerm, uiFieldSpecNames);
        }
      });
  })

  // validate when using auto complete
  onAutoCompleteSelected(event: Event) {
    // IDS workaround: this is in a timeout because it must run after the focusOut event,
    // the control's value does not update the value before the focusOut event therefor validation
    // fails.
    setTimeout(() => {
      this.selectedField.name = event[ 2 ].label;
      this.onChange(true);
    });
  }

  onEdit = (context: { isEditing: boolean }, state: boolean) => {
    context.isEditing = state;
    this.isNewField = false;
    this.isEditing = false;
  }

  public sortOrderSource = (response: any, searchTerm: any) => {
    this.buildSortOrders();

    response(this.sortOrders);
  }

  private buildSortOrders() {
    this.sortOrders = [];
    this.sortOrders.push({ value: '' });
    const keys: Array<string> = Object.keys(this.setSpecs);

    for (const key of keys) {
      this.sortOrders.push({ value: key, label: key });
    }
  }

  public totalSource = (response: any, searchTerm: any) => {
    this.buildTotalTypes();

    response(this.totaling);
  }

  private buildTotalTypes() {
    this.totaling = [];

    const df = this.displayFields.find(col => col.index === this.selectedField?.index);
    if (this.isColumnarView) {
      // Should only support NONE and TOTAL
      this.totaling.push({ value: 'NONE', label: Soho.Locale.translate('totaling.option.label.none') });
      this.totaling.push({ value: 'TOTAL', label: Soho.Locale.translate('totaling.option.label.total') });
    } else if (df?.canTotal || df?.compute) {
      this.totaling.push({ value: 'NONE', label: Soho.Locale.translate('totaling.option.label.none') });
      this.totaling.push({ value: 'TOTAL', label: Soho.Locale.translate('totaling.option.label.total') });
      this.totaling.push({ value: 'RUNNING_TOTAL', label: Soho.Locale.translate('totaling.option.label.running') });
      this.totaling.push({ value: 'PERCENT_OF_TOTAL', label: Soho.Locale.translate('totaling.option.label.percent') });
    } else {
      this.totaling.push({ value: 'NONE', label: Soho.Locale.translate('totaling.option.label.none') });
    }
  }

  loadListNamesAndViews(event: Event, businessClassChanged: boolean) {
    const url = this.listUrlInfo ? this.listUrlInfo.reportPersonalizationUrl : this.url;
    this.lmFormRequestService.getListNamesAndViewsForBusClass(url, this.model.businessClass)
      .subscribe(
        (response: any) => {
          this.listNames = [];
          response.forEach((listInfo) => {
            this.listNames.push({ value: listInfo.listName, label: listInfo.listName });

            const listViews = [];
            listInfo.listViews.forEach((listInfoViewName) =>
              listViews.push({ value: listInfoViewName, label: listInfoViewName }));

            this.allViewNames[ listInfo.listName ] = listViews;
          });

          if (!businessClassChanged) {
            this.viewNames = this.loadViews();
            this.noChartView = (this.viewNames && this.viewNames.length === 1) ? true : false;
            this.model.viewName = this.chartName ? this.chartName : 'List';
            return;
          }

          this.model.listName = this.listNames[ 0 ].value;
          this.onListChange(event);
          this.markForRefresh();
        },
        (error: any) => {
          // notify listeners
        });
  }

  loadViews(): any[] {
    return this.allViewNames [ this.model.listName ];
  }

  onSortOrderChanged(column: LMPersonalizationColumn) {
    this.dropDown.updated();
    this.onSortChange(column);
  }

  lmFieldLookupClickFunction = (
    event: any,
    lookup: SohoLookupStatic,
    clickArguments: any) => {

    if (!clickArguments) {
      return;
    }

    const personalizationComponent = clickArguments.grid.settings.userObject;
    personalizationComponent.onGetConditionQualifier(lookup, clickArguments.grid);
  };

  onLabelDirty() {
    if (this.selectedField.placeholder !== this.selectedField.label) {
      this.selectedField.placeholder = DOMPurify.sanitize(this.selectedField.placeholder, {
        FORBID_ATTR: [ 'href', 'src', 'cite', 'srcset' ],
      });
      this.selectedField.label = this.selectedField.placeholder;
    }
    this.onChange(false, false);
  }

  onLabelPristine() {
    this.onChange(false, false);
  }
  onFieldChange() {
    this.selectedField.added = true;
  }
  onChange(fieldChanged = false, resetValidation = true) {
    if (fieldChanged) {
      this.selectedField.added = true;
    } else {
      this.selectedField.updated = true;
    }

    this.selectedField.name = DOMPurify.sanitize(this.selectedField.name, {
      FORBID_ATTR: [ 'href', 'src', 'cite', 'srcset' ],
    });

    const rows = this.columnDataGridComponent.selectedRows();
    if (rows?.length > 0) {
      this.columnDataGridComponent.rowStatus(this.columnDataGridComponent.selectedRows()[0].idx, 'new', Soho.Locale.translate('RowDataChanged'));
      this.columnDataGridComponent.updateRow(this.columnDataGridComponent.selectedRows()[0].idx, this.selectedField);
    }

    // only way that i could get the context to work, really should just bite the bullet
    // and refactor!!!
    if (resetValidation) {
      this.selectedField.validated = false;
      this.selectedField.isValid = false;
    }
  }

  isModified(): boolean {
    for (const personalizationCol of this.displayFields){
      if (personalizationCol?.updated || personalizationCol?.added) {
        return true;
      }
    }

    return false;
  }

  onSortChange(column: LMPersonalizationColumn) {
    this.onChange(false, false);
    if (column.defaultSort) {
      const prevDefaultSort: LMPersonalizationColumn[] = this.displayFields.filter((field: LMPersonalizationColumn) => field.defaultSort && field.index !== column.index);
      if (prevDefaultSort.length > 0) {
        prevDefaultSort[0].defaultSort = false;
        this.columnDataGridComponent.updateRow(prevDefaultSort[0].index, prevDefaultSort[0]);
      }
      this.model.defaultSortColumn = column.index.toString();
    }
    this.buildSortInfo();
    this.buildSubtotalByInfo();
  }

  onSortDescendingChange(column: LMPersonalizationColumn) {
    this.model.sortDescending = column.sortDescending;
    this.onChange(false, false);
    this.buildSortInfo();
  }

  // validate when not using auto complete
  validateField(field?: LMPersonalizationColumn) {

    if (!field) {
      field = this.selectedField;
    }

    // if (!field.validated ) {
    const rowNumber = field.index === 0 || field.index < this.columnDataGridComponent.dataset.length ? field.index : this.columnDataGridComponent.selectedRows()[0]?.idx;
    this.fieldAlert = this.alerts.find((alert: SohoAlertDirective) => (alert.elementRef.nativeElement as Element).getAttribute('id') === 'name');

    if (this.fieldAlert) {
      this.fieldAlert.removeAllMessages();
    }

    if (this.selectedField.type !== 'Field' || this.selectedField.name === '') {
      this.columnDataGridComponent.clearRowError(rowNumber);
      field.validated = true;
      field.isValid = true;
    } else {
      // this.alert.removeAllMessages();
      // this.columnDataGridComponent.clearRowError(field.index);
      this.fieldValidation$.next(this.selectedField.name);
    }
    // }
  }

  validAlerts(event?: SohoDataGridEditModeEvent, row?: number) {
    let validAlerts = true;
    const rowNumber = event ? event.row : row ? row : 0;

    if (!this.selectedField.alerts || this.selectedField.alerts === undefined) {
      validAlerts = true;
    } else if (this.selectedField.alerts.filter((fieldAlert: LMFieldEditorFieldAlert) => fieldAlert.rowStatus && fieldAlert.type === undefined).length > 0) {
      validAlerts = false;
    } else if (this.selectedField.alerts.filter((fieldAlert: LMFieldEditorFieldAlert) => fieldAlert.type === FieldAlertType.RED_ALERT ).length > 1) {
      validAlerts = false;
    } else if (this.selectedField.alerts.filter((fieldAlert: LMFieldEditorFieldAlert) => fieldAlert.type === FieldAlertType.YELLOW_ALERT ).length > 1) {
      validAlerts = false;
    } else if (this.selectedField.alerts.filter((fieldAlert: LMFieldEditorFieldAlert) => fieldAlert.type === FieldAlertType.GREEN_ALERT ).length > 1) {
      validAlerts = false;
    } else if (this.selectedField.alerts.filter((fieldAlert: LMFieldEditorFieldAlert) => fieldAlert.type === FieldAlertType.BLUE_ALERT ).length > 1) {
      validAlerts = false;
    } else if (this.selectedField.alerts.filter((fieldAlert: LMFieldEditorFieldAlert) => fieldAlert.type === FieldAlertType.ICON_ALERT ).length > 1) {
      validAlerts = false;
    } else if (this.selectedField.alerts.filter((fieldAlert: LMFieldEditorFieldAlert) => fieldAlert.iconName.trim() === '').length > 0) {
      validAlerts = false;
    } else if (this.selectedField.alerts.filter((fieldAlert: LMFieldEditorFieldAlert) => fieldAlert.condition === undefined).length > 0) {
      validAlerts = false;
    }

    if (!validAlerts) {
      this.columnDataGridComponent.showRowError(rowNumber, Soho.Locale.translate('FieldEditorFixAlert'), 'error');
      this.selectedField.isValid = false;
      this.selectedField.validated = true;
    } else {
      if (this.selectedField.isValid) {
        this.selectedField.validated = true;
        this.selectedField.isValid = true;
        this.columnDataGridComponent.clearRowError(rowNumber);
      }
    }
  }

  validateCompute(event?: Event) {
    setTimeout(() => {
      this.computeAlert = this.alerts.find((alert: SohoAlertDirective) => (alert.elementRef.nativeElement as Element).getAttribute('id') === 'compute');
      const field = this.selectedField;
      const rowNumber = field.index === 0 || field.index < this.columnDataGridComponent.dataset.length ? field.index : this.columnDataGridComponent.selectedRows()[0].idx;

      if (this.computeAlert) {
        this.computeAlert.removeAllMessages();
      }
      if (this.selectedField.name === '') {
        this.columnDataGridComponent.clearRowError(rowNumber);
        this.selectedField.validated = true;
        this.selectedField.isValid = true;
      } else {
        if (this.selectedField.name.indexOf('(') !== 0) {
          this.selectedField.name = '(' + this.selectedField.name;
        }

        if (this.selectedField.name.lastIndexOf(')') !== this.selectedField.name.length - 1) {
          this.selectedField.name += ')';
        }

        this.lmConfigurationService.computeIsValid(this.listUrlInfo ? this.listUrlInfo.reportPersonalizationUrl : this.url, this.model.businessClass, this.selectedField).subscribe((response: any) => {
          if (response.lplStatus !== 'LPL_VALID') {
            if (this.computeAlert) {
              this.computeAlert.addInlineMessage(response.message);
            }
            this.columnDataGridComponent.showRowError(rowNumber, response.message.error, 'error');
            this.selectedField.isValid = false;

          } else {
            this.columnDataGridComponent.clearRowError(rowNumber);
            this.selectedField.isValid = true;
          }
          this.selectedField.validated = true;
          this.ngZone.run(args => {
            this.buildTotalFieldInfo();
          });
        });
      }
    }, 10);
  }

  isRequired(id: string): string {
    // used to set the sohoxi required validator on the data-validate attribute on a control
    // return null means attribute is not set
    if (this.selectedField.validated) {
      return 'required';
    }
    return null;
  }

  // computeIsValid(): Observable<Response> {
  //   let formRequest: any = {
  //     requestType: 'validateCompute',
  //     param1: this.listSpec.busClassSpec.name,
  //     param2: this.selectedField.name,
  //     param3: this.selectedField.compute,
  //   };
  //
  //   let headers = new HttpHeaders();
  //   headers.append('Content-Type', 'application/json;charset=utf-8');
  //
  //   const compiledUrlTemplate = urltemplate.parse(this.listUrlInfo.reportPersonalizationUrl);
  //
  //   let url = compiledUrlTemplate.expand({ resourceId: this.listSpec.busClassSpec.name });
  //
  //   return <Observable<Response>> this.http.post(url, JSON.stringify(formRequest), {headers: headers}).pipe(
  //   catchError(error => this._handleError(error)));
  // }

  hasAlert(type: number) {
    if (!this.selectedField?.alerts) {
      return false;
    }

    if (this.selectedField.alerts.filter((fieldAlert: LMFieldEditorFieldAlert) => fieldAlert.type === type).length >= 1) {
      return true;
    }
    return false;
  }

  onGetFieldOperatorQualifier(context: { isEditing: boolean }, state: boolean) {
    const includeAudit = this.listSpec?.busListSpec?.isAudit || this.model?.dataOption === 'audit';

    const options: LMFieldPickerSelectOptions = {
      view: this.isCubeView ? 'Measures' : 'Fields',
      businessClass: this.model.businessClass,
      enableOperatorBuilder: this.enableOperator,
      includeAuditFields: includeAudit
    };

    let url = `${this.lmUrlUtilService.getBaseUrl()}/config/All`;
    url = this.lmUrlUtilService.propagateSessionKeys(url, '?');

    this.lmFieldValidatorService.fieldIsValid(this.selectedField.name, options.businessClass, null, url).pipe(
        switchMap((response: LMValidateFieldResponse) => {
          const options: LMFieldPickerOperatorOptions = {
            businessClass: this.model.businessClass,
            view: this.isCubeView ? 'Measures' : 'Fields',
            uiFieldSpec: response?.uiFieldSpec,
            operatorInfo: response?.operatorInfo,
            auditData: includeAudit
          };
          return this.lmFieldPickerService.openFieldOperatorDialog(options);
        }),
    ).subscribe((result: LMFieldPickerSelectResponse) => {
      this.handleRowSelectionEvent(result, false);
      this.fieldAlert?.elementRef?.nativeElement?.focus();
      this.ngZone.run(args => {
        this.buildTotalFieldInfo();
      });
    });
  }

  onGetFieldQualifier($event: Event) {
    const mode = this.isCubeView ? 'Measures' : 'Fields';
    const includeAudit = this.listSpec?.busListSpec?.isAudit || this.model?.dataOption === 'audit';
    const options: LMFieldPickerSelectOptions = {
      view: this.isCubeView ? 'Measures' : 'Fields',
      businessClass: this.model.businessClass,
      enableOperatorBuilder: this.enableOperator,
      includeAuditFields: includeAudit
    };

    let url = `${this.lmUrlUtilService.getBaseUrl()}/config/All`;
    url = this.lmUrlUtilService.propagateSessionKeys(url, '?');

    this.lmFieldValidatorService.fieldIsValid(this.fieldAlert?.elementRef?.nativeElement?.value, options.businessClass, null, url).pipe(
      switchMap((response: LMValidateFieldResponse) => this.lmFieldPickerService.openFieldPickerDialog(options, this.fieldLookUpUrl, this.modalPlaceholder, undefined, undefined)),
    ).subscribe((result: LMFieldPickerSelectResponse) => {
        this.handleRowSelectionEvent(result, false);  // false means not to validate, lets assume the picker builds valid fields!!!
        this.fieldAlert?.elementRef?.nativeElement?.focus();
        this.ngZone.run(args => {
          this.buildTotalFieldInfo();
        });
      });
  }

  onGetConditionQualifier(lookup: SohoLookupStatic, grid: SohoDataGridStatic) {
    const options: LMFieldPickerSelectOptions = {
      view: 'SimpleConditions',
      businessClass: this.model.businessClass
    };
    this.lmFieldPickerService.openFieldPickerDialog(options, this.fieldLookUpUrl, this.modalPlaceholder)
      .subscribe((result) => {
        this.handleConditionSelectionEvent(result, lookup, grid);
      });
  }

  setValidAlerts() {
    this.noRedAlert = !this.hasAlert(FieldAlertType.RED_ALERT);
    this.noYellowAlert = !this.hasAlert(FieldAlertType.YELLOW_ALERT);
    this.noGreenAlert = !this.hasAlert(FieldAlertType.GREEN_ALERT);
    this.noBlueAlert = !this.hasAlert(FieldAlertType.BLUE_ALERT);

    if (!this.noRedAlert && !this.noYellowAlert && !this.noGreenAlert && !this.noBlueAlert) {
      this.hasAllAlerts = true;
    } else {
      this.hasAllAlerts = false;
    }
  }

  private buildAlerts() {
    if (this.selectedField.alerts) {
      this.selectedField.alerts.forEach((fieldAlert: LMFieldEditorFieldAlert) => {
        this.setAlertIconImage(fieldAlert);
      });
    }
  }

  private setAlertIconImage(fieldAlert: LMFieldEditorFieldAlert) {
    switch (fieldAlert.type) {
      case FieldAlertType.RED_ALERT:
        fieldAlert.iconImage = 'error';
        break;
      case FieldAlertType.YELLOW_ALERT:
        fieldAlert.iconImage = 'alert';
        break;
      case FieldAlertType.GREEN_ALERT:
        fieldAlert.iconImage = 'success';
        break;
      case FieldAlertType.BLUE_ALERT:
        fieldAlert.iconImage = 'info-field';
        break;
      case FieldAlertType.ICON_ALERT:
        fieldAlert.iconImage = this.buildIconUrl(fieldAlert.iconName);
        break;
    }
  }

  onAlertTypeChanged(alertType: number) {
    const selectedAlert: LMFieldEditorFieldAlert[] =  this.alertOptions.filter(alert => alert.type === alertType);

    if (selectedAlert[0].type === FieldAlertType.ICON_ALERT) {
      this.iconAlert = '';
    } else {
      this.iconAlert = selectedAlert[0].iconName;
    }
  }

  ngOnInit() {
    if (this.listUrlInfo != null) {
      this.reportUrl = this.listUrlInfo.reportPersonalizationUrl;
      this.actorGroupSelectUrl = this.listUrlInfo.actorGroupSelectUrl;
      this.roleSelectUrl = this.listUrlInfo.roleSelectUrl;
      this.roleGroupSelectUrl = this.listUrlInfo.roleGroupSelectUrl;
    } else {
      this.actorGroupSelectUrl = this.actorGroupUrl;
      this.roleSelectUrl = this.roleUrl;
      this.roleGroupSelectUrl = this.roleGroupUrl;
    }

    this.conditionValid = true;
    this.displayFields = [];
    this.disableEdit = true;
    this.disableRemove = true;
    // this.disableMoveUp = true;
    // this.disableMoveDown = true;
    this.disableAsOfDate = false;
    this.filterMode = 'contains';
    this.model.dataOption = 'live';
    this.model.fontOffset = 0;
    this.model.orientation = 'landscape';
    this.model.asOfDate = '';
    this.model.actorGroup = '';
    this.confirmedMessageIds = [];

    this.separator = AppConstants.CONDITION_AND;
    this.canTotal = false;
    this.conditionNames = [];
    this.allowSharing = (this.mode === 'personalizeReport' || this.mode === 'createReportFromMenu' ||  this.mode === 'createReportFromBanner') && this.lmContextService.getContext().configuredFeatures.indexOf(AppConstants.FEATURE_UseAllActorGroups) !== -1;
    this.loadSharingOptions();
    this.disableTabs = false;
    if (this.mode === 'createReportFromBanner') {
      // this.listName = this.model.listName;
      this.model.listName = this.listName;
      this.model.titleChanged = false;
      this.model.businessClass = this.businessClass;
      this.loadListNamesAndViews(null, false);
      let listPersonalizationUrl = `${this.lmUrlUtilService.getBaseUrl()}/static/${this.lmContextService.getContext().webApp}?resources=ListPersonalization.html` +
      `&resourceName=${this.businessClass}.${this.listName}${ this.userFolderId ? '&userfolder=' + this.userFolderId : '' }&fragment=true&output=spec`;
      listPersonalizationUrl = this.lmUrlUtilService.propagateSessionKeys(listPersonalizationUrl, '&');
      this.retrievePersonalization(listPersonalizationUrl);
    } else {
      if (this.reportType === 'ReportAddToExisting') {
        let personalizeReportUrl = `${this.lmUrlUtilService.getBaseUrl()}/list/${this.businessClass}.${this.listName}?${ this.userFolderId ? '&userfolder=' + this.userFolderId : '' }&fragment=true&output=spec`;
        personalizeReportUrl = this.lmUrlUtilService.propagateSessionKeys(personalizeReportUrl, '&');

        this.lmSpecService.getListSpec(personalizeReportUrl)
          .subscribe((response: LMListSpecResponse | LMSystemException) => {
            this.listUrlInfo = (response as LMListSpecResponse).listUrlInfo;
            this.listSpec = (response as LMListSpecResponse).listSpec;
            this.initializeListInfo();
        });
      } else {
        this.initializeListInfo();
      }
    }

    this.fieldValidation$.pipe(
      switchMap((fieldName) => this.lmFieldValidatorService.fieldIsValid(fieldName, this.model.businessClass, this.model.listName, this.listUrlInfo ? this.listUrlInfo.reportPersonalizationUrl : this.url))
    ).subscribe(response => {
      const rowNumber = this.selectedField.index === 0 || this.selectedField.index < this.columnDataGridComponent.dataset.length ? this.selectedField.index : this.columnDataGridComponent.selectedRows()[0]?.idx;

      if (this.fieldNameComponent) {
        this.selectedField.name = this.fieldNameComponent.getValue();
      }
      const df = this.displayFields.find(col => col.index === this.selectedField?.index);

      if (response.lplStatus === 'LPL_VALID') {
        this.selectedField.uiFieldSpec = response.uiFieldSpec;
        this.selectedField.hasOperator = response.operatorInfo !== undefined;
        this.selectedField.supportsOperator = this.isCubeView || this.lmFieldPickerService.supportsFieldOperator(response.uiFieldSpec);
        this.selectedField.canTotal = response.message.canTotalField;
        this.selectedField.canUpdate = response.message.canUpdateField;
        this.columnDataGridComponent.clearRowError(rowNumber);
        this.selectedField.isValid = true;

        if (df) {
          df.uiFieldSpec = this.selectedField.uiFieldSpec;
          df.supportsOperator = this.selectedField.supportsOperator;
          df.hasOperator = this.selectedField.hasOperator;
          df.canUpdate = this.selectedField.canUpdate;
          df.canTotal = this.selectedField.canTotal;
        }
      } else {
        df.name = this.selectedField.name;
        df.supportsOperator = false;
        df.hasOperator = false;
        df.canUpdate = false;
        df.canTotal = false;
        // this.fieldAlert.addInlineMessage(response.message.error, 'error');
        this.columnDataGridComponent.showRowError(rowNumber, response.message.error, 'error');
        this.selectedField.isValid = false;
      }

      this.validAlerts(undefined, rowNumber);
      this.selectedField.validated = true;
      this.ngZone.run(args => {
        this.buildTotalFieldInfo();
        this.updateHasTotaling();
      });
    });

    this.registerCustomRules();

    this.testVersion3 = this.lmContextService.testVersion() === AppConstants.TESTVERSION_V3;
    this.showLabelText = Soho.Locale.translate('ShowLabel');
    this.showLabel = true;
    this.filterConditionChanged = false;
    this.sortByHeaderTitle = Soho.Locale.translate('sortByHeaderTitle');
    this.sortByHelpText = Soho.Locale.translate('SortingHelpText');
    this.subtotalByHeaderTitle = Soho.Locale.translate('SubtotalByHeaderTitle');
    this.subtotalByHelpText = Soho.Locale.translate('SubtotalHelpText');
    this.totalFieldsHeaderTitle = Soho.Locale.translate('TotalFieldsHeaderTitle');
    this.totalFieldsHelpText = Soho.Locale.translate('TotalFieldsHelpText');
    this.columnTotalWidgetTitle = Soho.Locale.translate('ColumnTotalWidgetTitle');
    this.columnTotalHelpText = Soho.Locale.translate('ColumnTotalHelpText');
    this.addColumnCountButtonText = Soho.Locale.translate('AddColumnCountButtonText');
    this.emptyMessageColumnTotalFields = Soho.Locale.translate('EmptyMessageColumnTotalFields');
    this.summaryTotalWidgetTitle = Soho.Locale.translate('SummaryTotalWidgetTitle');
    this.summaryTotalHelpText = Soho.Locale.translate('SummaryTotalHelpText');
    this.addSummaryTotalFieldButtonText = Soho.Locale.translate('AddSummaryTotalFieldButtonText');
    this.emptyMessageSummaryTotalFields = Soho.Locale.translate('EmptyMessageSummaryTotalFields');

    this.enableOperator = this.isCubeView ? this.listSpec?.cubeOptions?.hasPeriodDimension : false;
    if (this.lmContextService.isConfigFeatureEnabled(AppConstants.FEATURE_Configuration)) {
      this.enableOperator = true;
    }
  }

  ngAfterViewInit() {
    if (!this.isCubeView) {
      this.conditionAlert = this.alerts.find((alert: SohoAlertDirective) => (alert.elementRef.nativeElement as Element).getAttribute('id') === 'filterCriteria');
      this.conditionAlert.addInlineMessage(Soho.Locale.translate('ListPersonalizationFilterCriteriaInfoMessage'), 'info', true, false);
    }
    this.instanceSelectionValidator$.pipe(
      takeUntil(this.unsubscribe$),
      debounceTime(1250),
      distinctUntilChanged())
      .subscribe(value => {
        this.filterConditionChanged = this.filterConditionInitial !== value;
        this.validateInstanceSelection();
      });

    // Do not do first here. This subscription will be active until dialog is closed.
    // The dialog service will complete and close this subject.
    this.dialog$.subscribe((result: LMReportPersonalizationDialogResult) => {
      if (result.status === LMReportPersonalizationDialogResultCode.REPORT_PERSONALIZATION_DIALOG_OK && this.conditionValid) {
        // if (this.displayFields.filter((field: LMPersonalizationColumn) => !field.validated).length > 0) {
        //   this.validateFields();
        // } else {
        //   if (this.displayFields.filter((field: LMPersonalizationColumn) => field.isValid).length === this.displayFields.length) {
        if (this.mode === 'createReportFromBanner') {
          let listUrl = `${this.lmUrlUtilService.getBaseUrl()}/list/${this.model.businessClass}.${this.model.listName}`;
          listUrl = this.lmUrlUtilService.propagateSessionKeys(listUrl, '?');
          this.runCreateReport(listUrl, result.viewReport);
        } else if ((this.mode === 'createReportFromMenu' || this.mode === 'personalizeReport') && !this.personalizationExists) {
          const listUrl = this.dataViewSet?.listUrl ? this.dataViewSet.listUrl : this.lmUrlUtilService.buildSavePersonalizationUrl(this.listUrlInfo, this.listSpec);
          this.runCreateReport(listUrl, result.viewReport);
        } else {
          this.runPersonalize();
        }
        //   }
        // }
      }
      if (result.status === LMReportPersonalizationDialogResultCode.REPORT_PERSONALIZATION_DIALOG_RESET) {
        this.runReset();
      }
    });
    if (this.mode === 'createReportFromBanner') {
      this.tabs.select('tabs-normal-column');
    }
  }

  private markForRefresh() {
    this.changeDetectionRef.markForCheck();
  }

  private initializeListInfo() {
    this.model.businessClass = this.listSpec?.busClassSpec?.name || this.businessClass;
    this.model.listName = this.listSpec?.busListSpec?.name || this.listName;
    this.filterConditionInitial =  this.filterCondition;
    this.model.conditionString = this.filterCondition;
    this.model.includeBaseFilter = this.includeBaseFilter;
    this.model.titleChanged = false;
    this.model.fontOffset = this.listSpec?.busListSpec.fontOffset || 0;
    this.model.orientation = this.listSpec?.busListSpec.orientation || 'landscape';
    this.updatePdfFontOffsetOption(this.model.fontOffset);

    this.isColumnarView = this.listSpec?.busListSpec ? this.listSpec?.busListSpec.implementsColumnarView : false;
    if (this.listSpec?.busListSpec.implementsCubeView) {
      this.isCubeView = true;
      // this.cubeViewState = this.listState;
      this.cubeParent = 'reportpersonalization';
      if (this.listSpec.cubeOptions.columnViews) {
        let columnView: LMColumnView;
        if (this.cubeViewState?.cubeOverrides?.columnView) {
          columnView = this.listSpec.cubeOptions.columnViews.find((c) => c.name === this.cubeViewState.cubeOverrides.columnView);
        } else {
          columnView = this.listSpec.cubeOptions.columnViews.find((c) => !!c.default);
        }
        if (!columnView) {
          columnView = this.listSpec.cubeOptions.columnViews[ 0 ];
        }
        this.cubeColumnView = columnView.name;
      }
    }
    const listPersonalizationUrl = `${this.listUrlInfo.listPersonalizationUrl}&resourceName=${this.model.businessClass + '.' + this.model.listName}` +
      `&fragment=true&output=spec${this.cubeColumnView ? '&colView=' + this.cubeColumnView : ''}`;

    this.loadListNamesAndViews(null, false);

    this.retrievePersonalization(listPersonalizationUrl);
  }

  retrievePersonalization(listPersonalizationUrl: string): void {
    if (this.mode === 'personalizeReport' || this.mode === 'createReportFromMenu' || this.mode === 'createReportFromBanner' || this.reportType === 'ReportAddToExisting') {
      listPersonalizationUrl = this.lmUrlUtilService.addParamToUrl(listPersonalizationUrl, "reportPersonalization", "true");
    }

    this.lmHtmlPageUtilService.getListPersonalizationSpec(listPersonalizationUrl)
      .subscribe((response: LMPersonalizationResponse) => {
        if ((this.mode === 'createReportFromBanner' || this.reportType === 'ReportAddToExisting') && !response.implementsCubeView) {
          this.displayFields = this.selectedFields;
        } else {
          // Cube Report from Banner, create report from menu and personalization
          this.displayFields = response.displayFields;
        }

        this.model.listType = response.listType;
        this.model.charts = response.charts;
        this.model.showLines = response.showLines;
        // this.pageSizes = this.getPageSizes(response.showLines); //DPB
        this.showTotalsOnly = response.showTotalsOnly;
        this.suppressSubtotals = response.suppressSubTotals;
        this.summaryTotalFields = response.summaryTotalFields;
        this.subtotalOverride = response.subtotalBy;
        this.model.showGridLines =  response.showGridLines;
        this.model.suppressHeader = response.suppressHeader;
        this.model.suppressFooter = response.suppressFooter;

        this.model.isReport = this.mode === 'personalizeReport' || this.mode === 'createReportFromMenu' || this.mode === 'createReportFromBanner' || this.reportType === 'ReportAddToExisting';
        this.model.implementsAuditing = response.implementsAuditing;
        this.model.implementsEffectiveDated = response.implementsEffectiveDated;
        this.model.implementsArchivable = response.implementsArchivable;

        this.isPrimaryList = response.dataView?.isPrimaryList;
        this.conditionNames = response.conditionNames;
        this.fieldLookUpUrl = response.fieldLookUpUrl;
        this.originalTitle = response.dataView?.listTitle;
        this.setSpecs = response.setSpecs;
        this.model.defaultSortColumn = response.dataView?.defaultSortField; // response.dataView.defaultSortField.toString();
        this.model.sortDescending = response.dataView?.sortDescending ? true : false;
        this.model.baseFilter = response.dataView?.baseFilter;
        this.appReport = response.appReport || this.appReport;

        if (response.appReport && this.mode !== 'personalizeList') {
          const reportState = this.lmReportsCatalogStateService.getCatalogReportState();
          
          if (Object.keys(reportState || {})?.length) {
            // clear cache so it won't retrieve the last dialog's report category state
            this.lmReportsCatalogStateService.deleteCatalogReportState();
          }

          this.model.module = this.appReport.module?.value || '';
          this.model.category = this.appReport.category?.value || '';
          this.model.description = this.appReport.description;

          this.appReport.modules = [ this.appReport.module ];
          this.appReport.categories = [ this.appReport.category ] ;

          this.isApplicationReport = true;
        }

        if (this.mode === 'personalizeList') {
          this.model.name = this.originalTitle;
        } else if (this.mode === 'createReportFromMenu') {
          this.model.name = '';
          this.isEditing = true;
        } else {
          this.model.name = this.listTitle ? this.listTitle : this.model.name;
        }

        if (this.mode === 'createReportFromMenu' || this.mode === 'personalizeReport') {
          this.includeBaseFilter = response.includeBaseFilter;
          // set the condition if we are creating a report from a report or
          // personalizing a report
          const createReportFromReport = this.listSpec?.userFolder || this.userFolderId;
          if ((createReportFromReport && this.createReportMode) ||  !this.createReportMode) {
            this.model.conditionString =  response.dataView.manualCondition;
          }

          if (response.implementsCubeView) {
            this.isCubeView = true;
          } else {
            this.isColumnarView = false;
          }
          if (response.implementsCubeView) {
            this.isCubeView = true;
            // this.cubeViewState = {};
            this.cubeParent = 'reportpersonalization';
          } else {
            this.isCubeView = false;
            // this.cubeViewState = {};
            this.cubeParent = null;
          }
        }

        if (this.mode === 'personalizeList') {
          this.model.conditionString = response.dataView.manualCondition;
        } else if (this.mode === 'createReportFromMenu' || this.mode === 'createReportFromBanner') {
          if (this.listSpec?.userFolder) {
            this.model.conditionString = response.dataView.manualCondition;
          } else {
            this.model.baseFilter = response.dataView.manualCondition;
            this.model.conditionString = "";
          }
        }

        this.initializeValidation();
        this.initializeSelectedField(undefined, 0);
        this.initializeSort();
        this.buildDisplayFieldTable();
        this.buildSortInfo();
        this.buildTotalFieldInfo();
        this.buildSummaryTotalFieldInfo();
        this.updateHasTotaling();
        this.buildSubtotalByInfo();
        this.buildSortOrders();
        this.buildTotalTypes();

        if (response.dataView.fields) {
          const sharedWith = response.dataView.fields[this.SHARED_WITH_OPTION_FIELD];
          const dataOption = response.dataView.fields[this.DATA_OPTION_FIELD];
          const actorGroup = response.dataView.fields[this.ACTOR_GROUP_FIELD];
          const role = response.dataView.fields[this.ROLE_FIELD];
          const roleGroup = response.dataView.fields[this.ROLE_GROUP_FIELD];
          const asOfDate = response.dataView.fields[this.AS_OF_DATE_FIELD];
          const pdfOffset = response.dataView.fields[this.PDF_OFFSET_FIELD];
          const pdfOrientation = response.dataView.fields[this.PDF_ORIENTATION_FIELD];
          const chartName = response.dataView.fields[this.CHART_NAME_FIELD] ? response.dataView.fields[this.CHART_NAME_FIELD] : this.chartName;

          if (sharedWith) {
            this.model.sharing = sharedWith;

            if ((this.mode === 'createReportFromMenu' || this.mode === 'personalizeReport') && !this.personalizationExists) {
              this.model.sharing = this.PRIVATE_SHARING_OPTION;
            }

            if (this.model.sharing === this.GROUP_SHARING_OPTION && actorGroup) {
              this.model.actorGroup = actorGroup;
            } else if (this.model.sharing === this.ROLE_SHARING_OPTION && role) {
              this.model.role = role;
            } else if (this.model.sharing === this.ROLEGROUP_SHARING_OPTION && roleGroup) {
              this.model.roleGroup = roleGroup;
            }
          }

          if (dataOption) {
            // the data option from the folder may be live, but cube and columnar need
            // to swtich to analytics or columnar
            if (response.implementsCubeView) {
              this.model.dataOption = 'analytics';
            } else if (response.implementsColumnarView) {
              this.model.dataOption = 'columnar';
            } else {
              this.model.dataOption = dataOption;
            }

            if ((this.model.dataOption === 'live' || this.model.dataOption === 'archive') && asOfDate) {
              this.model.asOfDate = this.lmFormatUtilService.yyyymmddToDisplay(asOfDate);
            }
          }
          if (pdfOffset) {
            this.model.fontOffset = pdfOffset;
            this.updatePdfFontOffsetOption(pdfOffset);
          }

          if (pdfOrientation) {
            this.model.orientation = pdfOrientation;
          }

          if (chartName) {
            this.model.viewName = chartName;
          }
        } else {

          if (response.isAnAuditList) {
            this.model.dataOption = 'audit';
          } else if (response.implementsColumnarView) {
            this.model.dataOption = 'columnar';
          } else if (response.implementsCubeView) {
            this.model.dataOption = 'analytics';
          }

        }

        const info: any = {};
        Object.assign(info, this.model);
        // info.isReport = this.mode === 'personalizeReport' || this.mode === 'createReportFromMenu' || this.mode === 'createReportFromBanner' || this.reportType === 'ReportAddToExisting';
        // info.implementsAuditing = response.implementsAuditing;
        // info.implementsEffectiveDated = response.implementsEffectiveDated;
        // info.implementsArchivable = response.implementsArchivable;
        this.model = info;
        this.markForRefresh();
        setTimeout(() => {
          if (this.columnDataGridComponent && this.columnDataGridComponent.dataset.length > 0) {
            this.columnDataGridComponent.selectRows([ 0 ]);
            this.initializeAlert();
            this.accordionComponent.expand('detailHeader');
          }
        });
      });
  }

  private buildSortOrdersCellOptions() {
    const sortOrdersCellOptions: SohoGridCellOption[] = [];
    sortOrdersCellOptions.push({ value: ' ', label: ' ' });
    const keys: Array<string> = Object.keys(this.setSpecs);
    keys.map(value => sortOrdersCellOptions.push({ value, label: value }));
    return sortOrdersCellOptions;
  }

  private isSupportedTotalType(totalType: DisplayFieldTotalType): boolean {
    if (this.isColumnarView) {
      return totalType === 'NONE' ||  totalType === 'TOTAL';
    } else {
      return true;
    }
  }

  buildDisplayFieldTable(): void {
    const orderColumn: SohoDataGridColumn = {
      id: 'rowReorder',
      name: '',
      field: 'id',
      align: 'center',
      sortable: false,
      formatter: Soho.Formatters.RowReorder,
      width: 20,
      resizable: false
    };
    const labelColumn: SohoDataGridColumn = {
      id: 'label',
      name: Soho.Locale.translate('ListLabel'),
      sortable: false,
      field: 'label',
      formatter: customFormatter,
      click: (e: any, args: any) => {
        console.log('link was clicked', args);
      },
      textOverflow: 'ellipsis'
    };

    const fieldColumn: SohoDataGridColumn = {
      id: 'field',
      name: Soho.Locale.translate('ListField'),
      sortable: false,
      field: 'field',
      formatter: customFormatter,
      click: (e: any, args: any) => {
        console.log('link was clicked', args);
      },
      textOverflow: 'ellipsis',
      hidden: true
    };

    const PAGING_COLUMNS: SohoDataGridColumn[] = [
      orderColumn,
      labelColumn,
      fieldColumn
      // nameColumn,
      // typeColumn,
      // allowUpdateColumn,
      // hasAlertColumn,
      // sortOrder,
      // totalColumn
    ];

    const COLUMNAR_PAGING_COLUMNS: SohoDataGridColumn[] = [
      orderColumn,
      labelColumn,
      fieldColumn
    ];

    this.columnGridOptions = <SohoDataGridOptions> {
      columns: this.isColumnarView ? COLUMNAR_PAGING_COLUMNS : PAGING_COLUMNS,
      dataset: this.displayFields,
      selectable: 'single',
      paging: false,
      rowReorder: true,
      editable: false,
      rowHeight: 'short',
      isList: true,
      emptyMessage: { title: 'Display Fields', info: Soho.Locale.translate('ListPersonalizationNoFieldsMessage') },
      showDirty: true,
      enableTooltips: true,
    };

    // Now using 'light datagrid header color
    this.columnGridOptions['headerBackgroundColor'] = 'light';
  }

  loadSharingOptions() {
    this.sharing = [];
    this.sharing.push({ value: this.PRIVATE_SHARING_OPTION, label: Soho.Locale.translate('CreateReportPrivate') });
    this.sharing.push({ value: this.GROUP_SHARING_OPTION, label: Soho.Locale.translate('CreateReportGroup') });
    this.sharing.push({ value: this.PUBLIC_SHARING_OPTION, label: Soho.Locale.translate('CreateReportPublic') });
    this.sharing.push({ value: this.ROLE_SHARING_OPTION, label: Soho.Locale.translate('CreateReportRoleLabel') });
    this.sharing.push({ value: this.ROLEGROUP_SHARING_OPTION, label: Soho.Locale.translate('CreateReportRoleGroupLabel') });
    this.model.sharing = this.PRIVATE_SHARING_OPTION;
  }

  onAddField() {
    this.selectedField = {
      index: Date.now(),
      type: 'Field',
      name: '',
      label: null,
      placeholder: '',
      allowUpdate: false,
      canUpdate: true,
      sortOrder: '',
      totaling: 'NONE',
      canTotal: true,
      alerts: [],
      compute: false,
      added: true,
      defaultSort: false,
      sortDescending: false,
      isValid: true,
      validated: true,
    };

    this.isNewField = true;
    this.displayFields.push(this.selectedField);
    this.columnDataGridComponent.dataset = this.displayFields;
    this.columnDataGridComponent.rowStatus(this.displayFields.length - 1, 'new', 'column added'); // TODO transalation
    this.columnDataGridComponent.selectRows(this.columnDataGridComponent.dataset.length - 1);
    this.onRowClicked(null, this.columnDataGridComponent.dataset.length - 1);

    const selectedElement = document.getElementById('columnDataGridComponent');

    if (selectedElement) {
      this.lmCommonUtilService.scrollIntoView(selectedElement);
    }

    setTimeout(() => {
      const labelFieldElement = document.getElementById('name');
      labelFieldElement.focus();
    });
  }

  onAddCompute() {
    this.selectedField  = {
      index: Date.now(),
      type: 'Field',
      name: '',
      label: '',
      placeholder: '',
      allowUpdate: false,
      canUpdate: false,
      sortOrder: '',
      totaling: 'NONE',
      canTotal: true,
      alerts: [],
      compute: true,
      added: true,
      defaultSort: false,
      sortDescending: false,
      isValid: true,
      validated: true,
    };
    this.displayFields.push(this.selectedField);

    this.columnDataGridComponent.dataset = this.displayFields;
    this.columnDataGridComponent.rowStatus(this.displayFields.length - 1, 'new', 'column added'); // TODO transalation

    this.columnDataGridComponent.selectRows(this.columnDataGridComponent.dataset.length - 1);

    this.onRowClicked(null, this.columnDataGridComponent.dataset.length - 1);

    const selectedElement = document.getElementById('columnDataGridComponent');

    if (selectedElement) {
      this.lmCommonUtilService.scrollIntoView(selectedElement);
    }

    this.buildTotalFieldInfo();
    setTimeout(() => {
      const labelFieldElement = document.getElementById('computeLabel');
      labelFieldElement.focus();
    }, 1);
  }

  onListViewClicked(event: any) {
    this.disableEdit = false;
    this.disableRemove = false;

    const rowNumber = event.row;
    this.selectedField = this.displayFields[event.row];
    // this.toggleMoveButtonsForRow(rowNumber);
  }

  private initializeSelectedField(event?: SohoDataGridRowClicked, row?: number) {
    this.disableEdit = false;
    this.disableRemove = false;

    const rowNumber = event ? event.row : row  !== undefined ? row : 0;
    this.selectedField = this.displayFields[rowNumber];
    if (this.selectedField) {
      this.selectedField.supportsOperator = this.isCubeView || this.lmFieldPickerService.supportsFieldOperator(this.selectedField.uiFieldSpec);
      this.editOperatorLabel = this.selectedField.hasOperator ? Soho.Locale.translate('FieldPicker_EditOperatorLink'): Soho.Locale.translate('FieldPicker_AddOperatorLink');
      // this.selectedField.isValid = false;
      // this.selectedField.validated = false;

      this.isNewField = !this.selectedField.name;

      if (!this.selectedField.placeholder) {
        this.selectedField.placeholder = this.selectedField.label;
      }

      if (!this.selectedField.validated) {
        if (!this.selectedField.compute) {
          this.validateField();
        } else {
          this.validateCompute();
        }
      }
    }
  }

  onRowClicked(event?: SohoDataGridRowClicked, row?: number) {
    const rowNumber = event ? event.row : row;

    if (rowNumber === undefined) {
      return;
    }

    this.initializeSelectedField(event, rowNumber);
    this.initializeSort();
    this.initializeAlert();
    this.buildTotalTypes();
    // this.toggleMoveButtonsForRow(rowNumber);
  }

  // private resetDialogInfo() {
  //   this.conditionValid = true;
  //   this.displayFields = [];
  //   this.disableEdit = true;
  //   this.disableRemove = true;
  //   // this.disableMoveUp = true;
  //   // this.disableMoveDown = true;
  //   this.disableAsOfDate = false;
  //   this.filterMode = 'contains';

  //   this.model.matchOption = this.MATCH_OPTION_ALL;
  //   this.model.dataOption = this.DATA_OPTION_LIVE;
  //   this.model.fontOffset = 0;
  //   this.model.fontOffsetOption = 'default';
  //   this.model.orientation = 'landscape';
  //   this.model.asOfDate = '';
  //   this.model.actorGroup = '';
  //   this.confirmedMessageIds = [];

  //   this.separator = AppConstants.CONDITION_AND;
  //   this.canTotal = false;
  //   this.conditionNames = [];

  //   this.model.listName = '';
  //   this.model.viewName = '';
  //   // this.model.name = '';
  //   this.model.sharing = this.PRIVATE_SHARING_OPTION;
  //   if (this.columnDataGridComponent) {
  //     this.columnDataGridComponent.dataset = [];
  //   }
  //   this.displayFields = [];
  //   this.selectedField = undefined;

  //   this.sortByInfo = [];
  //   this.subTotalByInfo = [];
  //   this.subtotalOverride = [];
  //   this.showTotalsOnly = false;
  //   this.suppressSubtotals = false;
  //   this.columnTotalFieldInfo = [];
  //   this.summaryTotalFields = [];
  //   this.summaryTotalFieldInfo = [];
  // }

  private initializeValidation() {
    this.displayFields.forEach(displayField => {
      displayField.isValid = true;
      displayField.validated = true;
    });
  }

  private initializeSort() {
    this.displayFields.forEach(displayField => {
      displayField.defaultSort = this.model.defaultSortColumn !== undefined && this.model.defaultSortColumn.toString() === displayField.index.toString() ? true : false;
      if (displayField.defaultSort) {
        displayField.sortDescending = this.model.sortDescending;
      }
    });
  }

  private initializeAlert() {
    this.alertGridOptions = undefined;
    this.setValidAlerts();
    if (!this.alertOptions) {
      this.buildAlertOptions();
    }
    if (this.selectedField.type === 'Field' && !this.selectedField.compute) {
      setTimeout(() => {
        this.buildAlertTable();
        this.buildAlerts();
        this.markForRefresh(); // TODO: need to figure out why this is needed!
      }, 1);
    }
  }

  private handleRowSelectionEvent(response: LMFieldPickerSelectResponse, resetValidation = true) {
    if (response === undefined) {
      return;
    }

    const uiFieldSpec = response.uiFieldSpec;

    const fieldName = response.fieldName;

    // if (this.lmFieldPickerService.isOTMField(uiFieldSpec)) {
    //   fieldName = 'first ' + fieldName;    // TODO how to handle this maybe the picker should automaticall add it if the not defined by the operator
    // }

    this.selectedField.name = fieldName;
    this.selectedField.placeholder = this.selectedField.name !== undefined ? uiFieldSpec.label : '';
    this.selectedField.uiFieldSpec = response.uiFieldSpec;
    this.selectedField.supportsOperator = this.isCubeView || this.lmFieldPickerService.supportsFieldOperator(response.uiFieldSpec);
    this.selectedField.hasOperator = response.operatorInfo ? true : false;
    this.editOperatorLabel = this.selectedField.hasOperator ? Soho.Locale.translate('FieldPicker_EditOperatorLink'): Soho.Locale.translate('FieldPicker_AddOperatorLink');
    if (this.selectedField.label !== null && this.selectedField.placeholder !== this.selectedField.label) {
      this.selectedField.label = this.selectedField.placeholder;
    }

    this.onChange(true, resetValidation);
    if (!this.selectedField.validated) {
      this.validateField();
    }

    this.changeDetectionRef.detectChanges();
  }

  private handleConditionSelectionEvent(response: LMFieldPickerSelectResponse, lookup: SohoLookupStatic, grid: SohoDataGridStatic) {
    const uiFieldSpec = response.uiFieldSpec;

    if (uiFieldSpec) {
      const rowValue = response.fieldName;
      const alertRow = grid.selectedRows()[0].idx;
      this.selectedField.alerts[alertRow].condition = rowValue;
      grid.updateRow(alertRow, this.selectedField.alerts[alertRow]);
      this.selectedField.updated = true;
      this.columnDataGridComponent.updateRow(this.columnDataGridComponent.selectedRows()[0].idx, this.selectedField);
    }
  }

  // private getRowFieldName(row: UIFieldSpec): string {
  //   if (row && row.parent) {
  //     if (row.parent.endsWith('agent')) {
  //       return `${row.parent}${row.fieldName}`;
  //     } else {
  //       return `${row.parent}.${row.fieldName}`;
  //     }
  //   }
  //   return row ? row.fieldName : undefined;
  // };

  onRemoveField() {
    const selectedRows = this.columnDataGridComponent.selectedRows();
    if (selectedRows.length === 1) {
      const selectedRow = selectedRows[0];
      if (this.selectedField.defaultSort) {
        this.model.defaultSortColumn = '';
        this.model.sortDescending = false;
      }
      this.columnDataGridComponent.removeSelected();
      this.columnDataGridComponent.selectRows(selectedRow.idx - 1);
      this.displayFields = this.columnDataGridComponent.dataset;
      this.initializeSelectedField(undefined, selectedRow.idx - 1);
    }

    this.buildSortInfo();
    this.buildSubtotalByInfo();
    this.buildTotalFieldInfo();
    this.updateHasTotaling();
  }

  private promptConfirmationMessage(message: string): Observable<ConfirmationDialogResult> {
    const msgConfirm: Observable<any> = new Observable(observer => {
      const dialogId =  'ConfirmationRequired';

      const buttons = [
        {
          id: this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.CANCEL ]),
          text: Soho.Locale.translate(LMDialogButtonKey.CANCEL),
          click: (e, modal) => {
            modal.close(true);
            observer.next(ConfirmationDialogResult.CONFIRMATION_CANCEL);
          }
        },
        {
          id: this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.OK ]),
          text: Soho.Locale.translate(LMDialogButtonKey.OK),
          click: (e, modal) => {
            modal.close(true);
            observer.next(ConfirmationDialogResult.CONFIRMATION_OK);
          },
          isDefault: true
        }
      ];

      // Show the confirmation message dialog.
      this.sohoMessageService
        .message({ allowedTags: '<div>, <span>, <p>' })
        .message(message)
        .buttons(buttons)
        .title(Soho.Locale.translate('ConfirmationRequired'))
        .open();
    });
    return msgConfirm;
  }

  // will not be used in the latest version of creatre reprort
  onListChange(event: Event) {
    if (this.model.viewName === '') {
      this.resetList();
    } else {
      if (this.isModified()) {
        this.promptConfirmationMessage(Soho.Locale.translate('ListPersonalizationListUnsavedChangesContinuingMsg')).subscribe((response: any) => {
          if (response === ConfirmationDialogResult.CONFIRMATION_OK) {
            this.resetList();
          } else {
            this.model.listName = this.listName;
            this.markForRefresh();
          }
        });
      } else {
        this.resetList();
      }
    }
  }

  onSharingChange(event: Event) {
    if (!this.actorGroupSharing) {
      this.model.actorGroup = '';
    }
    if (!this.roleSharing) {
      this.model.role = '';
    }
    if (!this.roleGroupSharing) {
      this.model.roleGroup = '';
    }
  }

  // will not be used in the latest version of create report
  resetList() {
    this.listName = this.model.listName;
    this.viewNames = this.loadViews();
    this.model.viewName = this.viewNames[ 0 ].value;
    this.noChartView = (this.viewNames && this.viewNames.length === 1) ? true : false;
    this.model.titleChanged = false;

    let listPersonalizationUrl = this.lmUrlUtilService.getBaseUrl() + '/static/' + this.lmContextService.getContext().webApp + '?resources=ListPersonalization.html&resourceName=' +
    this.model.businessClass + '.' + this.model.listName + '&fragment=true&output=spec';
    listPersonalizationUrl = this.lmUrlUtilService.propagateSessionKeys(listPersonalizationUrl, '&');

    this.retrievePersonalization(listPersonalizationUrl);
  }

  onLookupField = (data: LMDataView) =>  {
    if (this.model.sharing === 'Group') {
      return data.fields[this.ACTOR_GROUP_FIELD].value;
    } else if (this.model.sharing === 'Role') {
      return data.fields[this.ROLE_FIELD].value;
    } else if (this.model.sharing === 'RoleGroup') {
      return data.fields[ this.ROLE_GROUP_FIELD ].value;
    }
  }

  onLookupClick = (e, lookup) => {
    if (this.lmContextService.useSingleSelectList()) {
      this.showSelectListDialog();
    } else {
      this.showClassicSelectListDialog();
    }
  }


  private showSelectListDialog() {
    this.busyIndicator.activated = false;

    let selectListUrl;
    let businessClassName;
    let viewName;
    let title;

    if (this.model.sharing === 'Group') {
      selectListUrl = this.actorGroupSelectUrl;
      businessClassName = 'ActorGroup';
      viewName = 'ActorGroupHierarchyList';
      title = Soho.Locale.translate('CreateReportActorGroupLabel');
    } else if (this.model.sharing === 'Role') {
      selectListUrl = this.roleSelectUrl;
      businessClassName = 'Role';
      viewName = 'RoleList';
      title = Soho.Locale.translate('CreateReportRoleLabel');
    } else if (this.model.sharing === 'RoleGroup') {
      selectListUrl = this.roleGroupSelectUrl;
      businessClassName = 'RoleGroup';
      viewName = 'RoleGroupList';
      title = Soho.Locale.translate('CreateReportRoleGroupLabel');
    }

    this.lmSpecService.getListSpec(selectListUrl).subscribe((listSpecResponse: LMListSpecResponse) => {
      this.lmLoggerService.log([ 'LMReportPersonalizationDialogComponent', 'getListSpec() completed', listSpecResponse ]);

      const listUrlInfo = listSpecResponse.listUrlInfo;
      const listSpec = listSpecResponse.listSpec;

      const dataView: LMDataView = {
        resourceId: businessClassName,
        representativeText: '',
        status: '',
        name: '',
        action: '',
        busClassName: businessClassName,
        navigations: [],
        contextProperties: null,
        actionMeta: null,
        fields: {}
      };

      const selectRequestData: SelectRequestData = { viewType: 'form', viewName, dataView };

      this.lmSelectDialogService.showSelectListDialog({
        listUrlInfo,
        listSpec,
        title,
        sourceField: businessClassName,
        selectRequestData
      }).pipe(
        first()) // causes the subscription to complete after its messaged the first time
        .subscribe((selectResponse: LMSelectResponse) => {
          this.lmLoggerService.log([ 'LMReportPersonalizationDialogComponent', 'showSelectListDialog()', selectResponse ]);
          if (selectResponse?.status === AppConstants.STATUS_COMPLETED && selectResponse.dataViews) {
            const selectedDataView = selectResponse.dataViews[0];
            const fields = selectedDataView.fields;

            // sohoLookupComponent requires a data property on each array element
            const selectedData: Array<any> = [ { data: selectedDataView } ];
            this.ngZone.runOutsideAngular(() => {
              this.sohoLookup.setValue(selectedData);
            });

            if (fields.hasOwnProperty('ActorGroup')) {
              this.model.actorGroup = fields['ActorGroup'].value as string;
            } else if (fields.hasOwnProperty('Role')) {
              this.model.role = fields['Role'].value as string;
            } else if (fields.hasOwnProperty('RoleGroup')) {
              this.model.roleGroup = fields['RoleGroup'].value as string;
            }
          } else if (selectResponse?.status === AppConstants.STATUS_CANCEL) {
            this.ngZone.runOutsideAngular(() => {
              this.element?.nativeElement?.querySelectorAll('input[soho-lookup]')[0]?.focus();
            });
          }
        }
        );
    },
    (error: any) => {
      this.busyIndicator.activated = false;
      this.lmLoggerService.log([ 'LMReportPersonalizationDialogComponent error', error ]);
    });
  }

  // TODO: Remove the following and its supporting methods once we now longer support classic lookup selection
  private showClassicSelectListDialog() {
    this.busyIndicator.activated = true;

    let sharingUrl;
    let businessClassName;
    let businessViewName;
    let dialogTitle;

    if (this.model.sharing === 'Group') {
      sharingUrl = this.actorGroupSelectUrl;
      businessClassName = 'ActorGroup';
      businessViewName = 'ActorGroupHierarchyList';
      dialogTitle = Soho.Locale.translate('CreateReportActorGroupLabel');
    } else if (this.model.sharing === 'Role') {
      sharingUrl = this.roleSelectUrl;
      businessClassName = 'Role';
      businessViewName = 'RoleList';
      dialogTitle = Soho.Locale.translate('CreateReportRoleLabel');
    } else if (this.model.sharing === 'RoleGroup') {
      sharingUrl = this.roleGroupSelectUrl;
      businessClassName = 'RoleGroup';
      businessViewName = 'RoleGroupList';
      dialogTitle = Soho.Locale.translate('CreateReportRoleGroupLabel');
    }

    this.lmSpecService.getListSpec(sharingUrl).subscribe(
      (listSpecResponse: LMListSpecResponse) => {
        if ((listSpecResponse as LMSystemException)
        && ((listSpecResponse as LMSystemException).status === AppConstants.STATUS_SYSTEM_ERROR
          || (listSpecResponse as LMSystemException).status === AppConstants.STATUS_UNAUTHORIZED)) {
        // todo ppatton need to handle errors better
          return;
        }

        const listUrlInfo = listSpecResponse.listUrlInfo;
        const listSpec = listSpecResponse.listSpec;
        const dialogId = 'ReportShareGroup';
        const cancelButton = this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.CANCEL ]);
        const okButton = this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.OK ]);

        const buttonIds = {
          ok: okButton,
          cancel: cancelButton
        };

        const buttons = [
          {
            id: cancelButton,
            text: Soho.Locale.translate(LMDialogButtonKey.CANCEL),
            // tslint:disable-next-line:no-shadowed-variable > shadowed variable e
            // eslint-disable-next-line @typescript-eslint/no-shadow
            click: (e, modal) => {
              this.busyIndicator.activated = false;
              modal.close(true);
            },
            isDefault: true
          },
          {
            id: okButton,
            text: Soho.Locale.translate(LMDialogButtonKey.OK),
            isDefault: true,
            // tslint:disable-next-line:no-shadowed-variable > shadowed variable e
            // eslint-disable-next-line @typescript-eslint/no-shadow
            click: (e, modal) => {
              this.handleSelection();
            }
          }
        ];

        this.shareLookupDialog = this.sohoModalDialogService
          .modal(LMLookupDialogComponent)
          .options({ fullsize: 'responsive', noRefocus: true })
          .buttons(buttons)
          .title(dialogTitle)
          .isAlert(false)
          .autoFocus(false)
          .open()
          .apply((lookupDialog: LMLookupDialogComponent) => {
            this.ngZone.run(() => {
              lookupDialog.buttonIds = buttonIds;
              lookupDialog.listUrlInfo = listUrlInfo;
              lookupDialog.listSpec = listSpec;
              lookupDialog.selectRequestData = {
                viewType: 'form',
                viewName: businessViewName,
                dataView: {
                  resourceId: businessClassName,
                  representativeText: '',
                  status: '',
                  name: '',
                  action: '',
                  busClassName: businessClassName,
                  navigations: [],
                  contextProperties: null,
                  actionMeta: null,
                  fields: {}
                },
              };

              lookupDialog.triggerDetectChanges();

              // ---------------------------------------------------------------------
              // need to markForCheck on the next tick() so angular picks up the
              // the list that is added to the dialog in this apply method.
              // ---------------------------------------------------------------------

              // need to listen for all occurrences as will get a row selection for a 'deselection'
              this.lookupSelectionSubscription =
                  lookupDialog.lookupSelection.subscribe((event: LMLookupSelectionEvent) => {
                    this.lookupSelectionEvent = event;
                  });

              lookupDialog.navigatingToolbarEvent.pipe(first()).subscribe(() => {
                this.shareLookupDialog.close();
              });
            });
          })
          .afterClose(result => {
            this.busyIndicator.activated = false;

            if (this.lookupSelectionSubscription) {
              this.lookupSelectionSubscription.unsubscribe();
              this.lookupSelectionSubscription = null;
            }

            this.lookupSelectionEvent = null;
            this.shareLookupDialog = null;
          });
      },
      (error: any) => {
        this.busyIndicator.activated = false;
        this.lmLoggerService.log([ 'LMLookupDialog error', error ]);
      });
  }

  private handleSelection() {
    if (this.lookupSelectionEvent) {
      const result: Array<any> = this.lookupSelectionEvent.rows;
      if (result && Array.isArray(result) && result.length > 0) {
        const dataView: LMDataView = result[0].data;
        const fields = dataView.fields;

        this.sohoLookup.setValue(this.lookupSelectionEvent.rows);

        if (fields.hasOwnProperty('ActorGroup')) {
          this.model.actorGroup = fields['ActorGroup'].value as string;
        } else if (fields.hasOwnProperty('Role')) {
          this.model.role = fields['Role'].value as string;
        } else if (fields.hasOwnProperty('RoleGroup')) {
          this.model.roleGroup = fields['RoleGroup'].value as string;
        }
      }
    }

    this.shareLookupDialog.close();
  }

  private validateInstanceSelection(): void {
    if (this.model.conditionString === '') {
      this.conditionValid = true;
      this.updateInstanceSelectionAlert();
    } else {
      this.lmConfigurationService.conditionIsValid(this.model.conditionString, this.listUrlInfo ? this.listUrlInfo.reportPersonalizationUrl : this.url, this.model.businessClass)
        .subscribe((response: LMLplValidationResponse) => {
          this.conditionValid = response.lplStatus === 'LPL_VALID';
          this.updateInstanceSelectionAlert(response);
        });
    }
  }

  private updateInstanceSelectionAlert(lplValidationResponse?: LMLplValidationResponse): void {
    if (!lplValidationResponse || lplValidationResponse.lplStatus === 'LPL_VALID') {
      this.conditionAlert.removeAllMessages();
      this.conditionAlert.addInlineMessage(Soho.Locale.translate('ListPersonalizationFilterCriteriaInfoMessage'), 'info', true, false);
    } else {
      const validationError = lplValidationResponse.validationError;
      let alertMessage = lplValidationResponse.message;

      if (validationError) {
        alertMessage = validationError.errorDescription;
        // TODO this is not needed if we can hightlite the error text
        if (validationError.errorText) {
          alertMessage += ' ' + validationError.errorText;
        }
      }
      const alertType = validationError && validationError.isWarning ? 'info' : 'error';
      this.conditionAlert.addInlineMessage(alertMessage, alertType, true);
    }
  }

  // private conditionIsValid(value: string): Observable<LMLplValidationResponse> {
  //   let formRequest: any = {
  //     requestType: 'validateCondition',
  //     param1: this.listSpec.busClassSpec.name,
  //     param2: value
  //   };
  //
  //   let headers = new HttpHeaders();
  //   headers.append('Content-Type', 'application/json;charset=utf-8');
  //
  //   const compiledUrlTemplate = urltemplate.parse(this.listUrlInfo.reportPersonalizationUrl);
  //
  //   let url = compiledUrlTemplate.expand({resourceId: this.listSpec.busClassSpec.name});
  //
  //   return <Observable<LMLplValidationResponse>>this.http.post(url, JSON.stringify(formRequest), {headers: headers}).pipe(
  //       catchError(error => this._handleError(error)));
  // }

  onTitleDirty(event: SohoTrackDirtyEvent): void {
    if (this.model.name !== this.originalTitle) {
      this.model.titleChanged = true;
    } else {
      this.trackDirty.resetDirty();
    }
  }

  onTitleAfterResetDirty(event: SohoTrackDirtyEvent): void {
    this.model.titleChanged = false;
  }

  onTitlePristine(event: SohoTrackDirtyEvent): void {
    this.model.titleChanged = false;
  }

  public sharingSource = (response: any, searchTerm: any) => {
    response(this.sharing, true);
  }

  public businessClassSource = (response: any, searchTerm: any) => {
    response(this.businessClasses, true);
  }

  public listNameSource = (response: any, searchTerm: any) => {
    response(this.listNames, true);
  }

  public viewNameSource = (response: any, searchTerm: any) => {
    response(this.viewNames, true);
  }

  // private createReport(url: string, busClassName: string, dataView: LMReportPersonalizationDataView, displayFields?: any[], viewReport?: boolean): Observable<Response> {
  //   return this.createReportAndPersonalize(url, this.model.businessClass, this.dataView, this.displayFields, viewReport);
  // }
  //
  // private createReportAndPersonalize(url: string, busClassName: string, dataView: LMReportPersonalizationDataView, displayFields: any[], viewReport?: boolean): Observable<Response> {
  //   let formRequest: LMReportFormRequest = {
  //     requestType: 'createReportAndPersonalize',
  //     param1: displayFields,
  //     reportDataView: dataView,
  //     viewReport: viewReport
  //   };
  //
  //   return this.makeFormRequest(url, formRequest);
  // }
  //
  // private personalize(url: string, busClassName: string, dataView: LMReportPersonalizationDataView, displayFields: any[]): Observable<Response> {
  //   let formRequest: LMPersonalizeFormRequest = {
  //     requestType: 'saveListPersonalization',
  //     param1: displayFields,
  //     param2: dataView
  //   };
  //
  //   url = this.lmUrlUtilService.updateUrlParams(url, {userfolder: this.listSpec.userFolder});
  //   return this.makeFormRequest(url, formRequest);
  // }
  //
  // private resetPersonalization(url: string, busClassName: string, dataView: LMReportPersonalizationDataView, displayFields: any[]): Observable<Response> {
  //   let formRequest: LMPersonalizeFormRequest = {
  //     requestType: 'deleteListPersonalization'
  //   };
  //
  //   url = this.lmUrlUtilService.updateUrlParams(url, {userfolder: this.listSpec.userFolder});
  //   return this.makeFormRequest(url, formRequest);
  // }
  //
  // private makeFormRequest(url: string, formRequest: LMReportFormRequest | LMPersonalizeFormRequest): Observable<Response> {
  //   let headers = new HttpHeaders();
  //   headers.append('Content-Type', 'application/json;charset=utf-8');
  //
  //   return <Observable<Response>>this.http.post(url, JSON.stringify(formRequest), {headers: headers}).pipe(
  //       catchError(error => this._handleError(error)));
  // }
  //
  // private _handleError(error: Response) {
  //   // in a real world app, we may send the error to some remote logging infrastructure
  //   // instead of just logging it to the console
  //   this.lmLoggerService.log(error);
  //   return throwError(error || 'Server error');
  // }

  onBuildButtonEvent(event: Event) {
    const url = this.listUrlInfo ? this.listUrlInfo.fieldSearchUrl : this.fieldSearchUrl;
    const personalizationUrl = this.listUrlInfo ? this.listUrlInfo.reportPersonalizationUrl : this.url;
    const includeAudit = this.listSpec?.busListSpec?.isAudit || this.model?.dataOption === 'audit';
    const hasExistingCondition = this.model.conditionString?.trim().length > 0 ? true : false;

    this.lmFilterBuilderService.openBuilderDialog(this.model.businessClass, this.fieldLookUpUrl,
      url, personalizationUrl, hasExistingCondition, includeAudit).pipe(
      takeUntil(this.unsubscribe$),
      takeWhile((result: LMFilterBuilderResult) => (result.lplQuery && result.lplQuery !== this.model.conditionString)),
      flatMap(result => {
        const lplFieldPicker = result.lplQuery;
        if (result.dialogResult === FilterBuilderDialogResult.CONFIRMATION_OK && !this.model.conditionString) {
          return of(lplFieldPicker);
        }

        if (result.dialogResult === FilterBuilderDialogResult.CONFIRMATION_APPEND) {
          return of(`${this.model.conditionString} ${result.matchOption} ${result.lplQuery}`);
        }

        // dialogResult is null if there's no this.modelField.value
        if (!result.dialogResult || result.dialogResult === FilterBuilderDialogResult.CONFIRMATION_OVERWRITE) {
          return of(result.lplQuery);
        }
      })).subscribe((value: string) => {
      this.filterConditionChanged = this.filterConditionInitial !== value;
      this.model.conditionString = value;
      this.validateInstanceSelection();
      this.changeDetectionRef.detectChanges();
    });
  }

  buildAlertOptions() {
    this.alertOptions = [];

    this.alertOptions.push({ iconName: 'redAlert', type: FieldAlertType.RED_ALERT, label: 'Red Alert' });
    this.alertOptions.push({ iconName: 'yellowAlert', type: FieldAlertType.YELLOW_ALERT, label: 'Yellow Alert' });
    this.alertOptions.push({ iconName: 'greenAlert', type: FieldAlertType.GREEN_ALERT, label: 'Green Alert' });
    this.alertOptions.push({ iconName: 'blueAlert', type: FieldAlertType.BLUE_ALERT, label: 'Blue Alert' });
    this.alertOptions.push({ type: FieldAlertType.ICON_ALERT, label: 'Icon Alert' });
  }

  private buildAlertTable() {
    const iconImageColumn: SohoDataGridColumn = {
      id: 'iconImage',
      name: Soho.Locale.translate('ColumnEditorAlertLabel'),
      field: 'iconName',
      sortable: false,
      formatter: customAlertFormatter,
      // editor: Soho.Editors.Dropdown,
      isEditable: <SohoDataGridColumnIsEditableFunction>this.checkAlertEditable,
      contentVisible: <SohoDataGridColumnContentVisibleFunction>this.checkAlertCellContentVisible
    };

    const conditionColumn: SohoDataGridColumn = {
      id: 'condition',
      name: Soho.Locale.translate('ColumnEditorAlertConditionLabel'),
      field: 'condition',
      sortable: false,
      expandOnActivate: true,
      // editor: Soho.Editors.Dropdown,
      // options: this.buildAlertConditionCellOptions(),
      editor: Soho.Editors.Lookup,
      editorOptions: {
        editable: <SohoDataGridColumnIsEditableFunction>this.checkAlertEditable,
        click:    this.lmFieldLookupClickFunction,
        clickArguments: {
          column: {
            displayField: this.selectedField
          }
        }
      },
      // formatter: customAlertConditionFormatter,
      isEditable: <SohoDataGridColumnIsEditableFunction>this.checkAlertEditable,
      contentVisible: <SohoDataGridColumnContentVisibleFunction>this.checkAlertCellContentVisible
    };
    const conditionNegatedColumn: SohoDataGridColumn = {
      id: 'negated',
      name: Soho.Locale.translate('ColumnEditorAlertNegatedLabel'),
      field: 'negated',
      sortable: false,
      align: 'center',
      formatter: Soho.Formatters.Checkbox,
      editor: Soho.Editors.Checkbox,
      isEditable: <SohoDataGridColumnIsEditableFunction>this.checkAlertEditable,
      contentVisible: <SohoDataGridColumnContentVisibleFunction>this.checkAlertCellContentVisible
    };

    const mouseOverColumn: SohoDataGridColumn = {
      id: 'mouseOverText',
      width: 150,
      name: Soho.Locale.translate('ColumnEditorAlertMouseOverLabel'),
      field: 'mouseOverText',
      sortable: false,
      editor: Soho.Editors.Input,
      isEditable: <SohoDataGridColumnIsEditableFunction>this.checkAlertEditable
    };

    const PAGING_COLUMNS: SohoDataGridColumn[] = [
      iconImageColumn,
      conditionColumn,
      conditionNegatedColumn,
      mouseOverColumn,
    ];

    this.alertGridOptions = <SohoDataGridOptions>{
      columns: PAGING_COLUMNS,
      dataset: this.selectedField.alerts,
      selectable: 'single',
      paging: false,
      rowReorder: false,
      editable: true,
      rowHeight: 'short',
      isList: true,
      emptyMessage: this.emptyMessage,
      showDirty: true,
      userObject: this
    };

    // Now using 'light datagrid header color
    this.alertGridOptions['headerBackgroundColor'] = 'light';
  }

  checkAlertEditable = (row: number, cell: number, value: string, column: SohoDataGridColumn, personalizationColumn: LMPersonalizationColumn, dataGrid: SohoDataGridStatic): boolean => {
    if (column.id === 'type') {
      return false;
    }
    return true;
  };

  checkAlertCellContentVisible = (row: number, cell: HTMLElement, value: any, column: SohoDataGridColumn, personalizationColumn: LMPersonalizationColumn): boolean => true;

  private buildAlertTypeCellOptions(): SohoGridCellOption[] {
    const alertTypeCellOptions: SohoGridCellOption[] = [];
    this.alertOptions.forEach(alert => {
      alertTypeCellOptions.push({ value: alert.type, label: alert.label });
    });
    return alertTypeCellOptions;
  }

  private buildAlertIconCellOptions(): SohoGridCellOption[] {
    const alertIconCellOptions: SohoGridCellOption[] = [];

    this.alertOptions.forEach(alert => {
      alertIconCellOptions.push({ value: alert.iconName, label: alert.iconName });
    });
    return alertIconCellOptions;
  }

  private buildAlertConditionCellOptions(): SohoGridCellOption[] {
    const alertConditionCellOptions: SohoGridCellOption[] = [];
    this.conditionNames.forEach((item) => {
      const condition: string = item.name;
      alertConditionCellOptions.push({ value: item.name, label: item.name });
    });
    return alertConditionCellOptions;
  }

  onAddAlert(type: number) {
    if (!this.selectedField.alerts) {
      this.selectedField.alerts = [];
    }

    this.onAlertTypeChanged(type);
    const fieldAlert = { type, iconName: this.iconAlert, iconImage: this.setAlertImage(type) };
    this.alertDataGridComponent.addRow(fieldAlert, 'bottom');

    this.alertDataGridComponent.setActiveCell(this.alertDataGridComponent.dataset.length - 1, 1);
    this.alertDataGridComponent.selectRows(this.alertDataGridComponent.dataset.length - 1);
  }

  onDeleteAlert() {
    this.alertDataGridComponent.removeSelected();
  }

  onAlertRowClicked(event?: SohoDataGridRowClicked, row?: number) {
    const rowNumber = event ? event.row : row;
    this.selectedAlert = rowNumber;
  }

  onAlertRowAdd(event: SohoDataGridAddRowEvent): void {
    if (!event || !event.value) {
      return;
    }
    this.selectedAlert = event.row;
    this.selectedField.alerts[event.row] = this.alertDataGridComponent.dataset[event.row];
    this.setValidAlerts();
    this.selectedField.updated = true;
    this.selectedField.validated = false;

    this.alertDataGridComponent.setActiveCell(this.selectedAlert, 1);
  }

  onAlertRowRemove(event: SohoDataGridRowRemoveEvent): void {
    if (!event) {
      return;
    }
    
    const alertsLength = this.selectedField.alerts?.length;
    if (alertsLength > 0) {
      this.selectedAlert = event.row;

      if (this.selectedAlert > alertsLength-1) {
        this.selectedAlert = alertsLength-1;
      }
    }

    this.setValidAlerts();
    this.selectedField.updated = true;
    this.selectedField.validated = false;

    this.alertDataGridComponent.setActiveCell(this.selectedAlert, 1);
    this.alertDataGridComponent.selectRows([ this.selectedAlert ]);
  }

  private setAlertImage(type: number): string {
    switch (type) {
      case FieldAlertType.RED_ALERT:
        return 'error';
      case FieldAlertType.YELLOW_ALERT:
        return 'alert';
      case FieldAlertType.GREEN_ALERT:
        return 'success';
      case FieldAlertType.BLUE_ALERT:
        return 'info-field';
    }
  }

  private setAlertType(type: number): string {
    switch (type) {
      case FieldAlertType.RED_ALERT:
        return 'redAlert';
      case FieldAlertType.YELLOW_ALERT:
        return 'yellowAlert';
      case FieldAlertType.GREEN_ALERT:
        return 'greenAlert';
      case FieldAlertType.BLUE_ALERT:
        return 'blueAlert';
    }
  }

  public onCellChange(event: SohoDataGridCellChangeEvent) {
    if (!event) {
      return;
    }

    if (event.column.id === 'type') {
      if (event.column.id === 'type') {
        if (this.selectedField.alerts.filter((fieldAlert: LMFieldEditorFieldAlert) => fieldAlert.type === event.value ).length > 1) {
          this.alertDataGridComponent.rowStatus(event.row, 'error', Soho.Locale.translate('FieldEditorAlertError'));
        } else {
          this.alertDataGridComponent.clearRowError(event.row);
        }
        this.onAlertTypeChanged(event.value);
        this.selectedField.alerts[event.row].iconName = this.iconAlert;
        this.setAlertIconImage(this.selectedField.alerts[event.row]);
      }
      // this.fieldValidated = false;
    }
    if (event.column.id === 'iconName') {
      this.setAlertIconImage(this.selectedField.alerts[event.row]);
      this.alertDataGridComponent.updateRow(event.row, this.selectedField.alerts[event.row]);
    }
    if (event.column.id === 'mouseOverText') {
      this.selectedField.alerts[event.row].mouseOverText = event.value;
    }
    if (event.column.id === 'condition') {
      this.selectedField.alerts[event.row].condition = event.value;
    }

    this.selectedAlert = event.row;
    this.alertDataGridComponent.updateRow(event.row, this.selectedField.alerts[event.row]);
    this.onChange(false, false);
  }

  private buildIconUrl(iconName: string): string {
    const imageUrl = this.lmUrlUtilService.getBaseUrl() + '/specicon/' + iconName;
    return this.lmUrlUtilService.updateUrlParams(imageUrl, this.lmContextService.getContext().contextSessionKeys);
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.fieldValidation$.complete();
  }

  private runCreateReport(url: string, viewReport: boolean): void {
    if (!this.sharingIsValid()) {
      const buttons = [  { text: Soho.Locale.translate('Ok'), click: (e, modal) => {modal.close(true);} } ];
      this.sohoMessageService
        .error()
        .title(Soho.Locale.translate('CreateReportErrorMessage'))
        .message(this.roleSharing ? Soho.Locale.translate('RoleIsRequiredErrorMessage') : Soho.Locale.translate('GroupIsRequiredErrorMessage'))
        .buttons(buttons)
        .open();
      return;
    }

    let cubeInfo: LMCubeReportInfo;
    if (this.isCubeView) {
      cubeInfo = this.buildCubeInfo();
    }
    this.updateSubtotalInfo();
    const userFolder = this.userFolderId || (this.listSpec ? this.listSpec.userFolder : null);

    this.lmConfigurationService.createReport(url, this.dataView, this.displayFields, userFolder, cubeInfo, viewReport)
      .subscribe(
        (res: any) => {
          this.lmReportsCatalogService.setStoredCatalogSpec(null); // Clear stored Catalog Reports so it retrieves fresh data
          if (res.status === AppConstants.STATUS_COMPLETED) {
            this.dialog$.next({
              status: LMReportPersonalizationDialogResultCode.REPORT_PERSONALIZATION_DIALOG_SAVED,
              message: Soho.Locale.translate('ReportIsCreatedMessage'),
              viewReport,
              reportUrl: res.reportUrl
            });
          }
          if (res.status === AppConstants.VIEW_EXCEPTION
                  || res.status === AppConstants.STATUS_SYSTEM_ERROR) {
            const message = res.message || Soho.Locale.translate('ReportWasNotCreatedMessage');
            const details = res.details || Soho.Locale.translate('ReportWasNotCreatedMessage');
            this.lmErrorUtilService.handleError(message, details, res.status, Soho.Locale.translate('ReportWasNotCreatedMessage'));
          }
          if (res.status === AppConstants.CONFIRMATION_REQUIRED) {
            this.lmConfirmationMessageService.promptConfirmationMessage({ message: res.message, okToAll: false })
              .subscribe(
                (confirmation: any) => {
                  if (ConfirmationDialogResult.CONFIRMATION_OK === confirmation) {
                    this.confirmedMessageIds.push(res.messageId);
                  }
                });
          }
        });
  }

  private runPersonalize(): void {
    let cubeInfo: LMCubeReportInfo;
    if (this.isCubeView) {
      cubeInfo = this.buildCubeInfo();
    }

    this.updateSubtotalInfo();

    const listUrl = this.lmUrlUtilService.buildSavePersonalizationUrl(this.listUrlInfo, this.listSpec);
    const userFolder = this.userFolderId || (this.listSpec ? this.listSpec.userFolder : null);
    this.lmConfigurationService.personalize(listUrl, this.dataView, this.displayFields, userFolder, cubeInfo)
      .subscribe(
        (res: any) => {
          if (userFolder) {
            this.lmReportsCatalogService.setStoredCatalogSpec(null); // Clear stored Catalog Reports so it retrieves fresh data
          }
          if (res.status === AppConstants.STATUS_COMPLETED) {
            this.dialog$.next({
              status: LMReportPersonalizationDialogResultCode.REPORT_PERSONALIZATION_DIALOG_SAVED,
              message: this.reportType === 'ReportAddToExisting' ? 
              this.lmFormatUtilService.formatMessage(Soho.Locale.translate('AddFieldsToExistingReportMessage'), [ this.model.name ]) : 
                Soho.Locale.translate('ListPersonalizationIsCreatedMessage')
            });
          }
          if (res.status === AppConstants.VIEW_EXCEPTION
              || res.status === AppConstants.STATUS_SYSTEM_ERROR) {
            const message = res.message || Soho.Locale.translate('ListPersonalizationWasNotCreatedMessage');
            const details = res.details || Soho.Locale.translate('ListPersonalizationWasNotCreatedMessage');
            this.lmErrorUtilService.handleError(message, details, res.status, Soho.Locale.translate('ListPersonalizationWasNotCreatedMessage'));
          }
          this.confirmedMessageIds = [];
          if (res.status === AppConstants.CONFIRMATION_REQUIRED) {
            this.lmConfirmationMessageService.promptConfirmationMessage({ message: res.message, okToAll: false })
              .subscribe(
                (confirmation: any) => {
                  if (ConfirmationDialogResult.CONFIRMATION_OK === confirmation) {
                    this.confirmedMessageIds.push(res.messageId);
                    this.runPersonalize();
                  }
                });
          }
        });
  }

  private runReset(): void {
    this.lmConfirmationMessageService.promptConfirmationMessage({
      title: this.lmContextService.simplifyOptionsMenu() ? Soho.Locale.translate('RemoveChangesMessage') : Soho.Locale.translate('ResetPersonalization'),
      dialogTitle: this.lmContextService.simplifyOptionsMenu() ? Soho.Locale.translate('RemoveChangesMessage') : Soho.Locale.translate('ResetPersonalization'),
      message: this.lmContextService.simplifyOptionsMenu() ? Soho.Locale.translate('RemoveChangesConfirmationMessage') : Soho.Locale.translate('ListPersonalizationResetConfirmationMessage'),
      okToAll: false
    }).subscribe(
      (confirmationResult: number) => {
        if (confirmationResult === ConfirmationDialogResult.CONFIRMATION_OK) {
          const userFolder = this.userFolderId || (this.listSpec ? this.listSpec.userFolder : null);
          if (userFolder) {
            this.lmReportsCatalogService.setStoredCatalogSpec(null); // Clear stored Catalog Reports so it retrieves fresh data
          }
          this.lmConfigurationService.runPersonalizeAction(this.listUrlInfo.reportPersonalizationUrl, { action: 'Delete', userfolder: userFolder })
            .subscribe((result: LMPersonalizeActionResponse) => {
              if (result.status === AppConstants.STATUS_COMPLETED) {
                this.dialog$.next({
                  status: LMReportPersonalizationDialogResultCode.REPORT_PERSONALIZATION_DIALOG_SAVED,
                  message: Soho.Locale.translate('ListPersonalizationIsDeletedMessage')
                });
              }
              if (result.status === AppConstants.VIEW_EXCEPTION
                      || result.status === AppConstants.STATUS_SYSTEM_ERROR) {
                this.lmErrorUtilService.handleError(Soho.Locale.translate('ListPersonalizationWasNotDeletedMessage'), Soho.Locale.translate('ListPersonalizationErrorMessage'));
              }
            });
        }
      }
    );
  }

  // private runResetPersonalization(): void {
  //   const compiledUrlTemplate = urltemplate.parse(this.listUrlInfo.transactionUrl);
  //   let url = compiledUrlTemplate.expand({resourceId: this.model.businessClass});
  //
  //   this.lmConfirmationMessageService.promptConfirmationMessage({
  //     title: 'Reset Personalization',
  //     dialogTitle: 'Reset Personalization',
  //     message: Soho.Locale.translate('ListPersonalizationResetConfirmationMessage'),
  //     okToAll: false
  //   })
  //       .subscribe(
  //           (confirmationResult: number) => {
  //             if (confirmationResult === ConfirmationDialogResult.CONFIRMATION_OK) {
  //               this.lmConfigurationService.resetPersonalization(url, this.model.businessClass, this.dataView, this.displayFields)
  //                   .subscribe(
  //                       (res: any) => {
  //                         if (res.status === AppConstants.STATUS_COMPLETED) {
  //                           this.dialog$.next({
  //                             status: LMReportPersonalizationDialogResultCode.REPORT_PERSONALIZATION_DIALOG_SAVED,
  //                             message: Soho.Locale.translate('ListPersonalizationIsDeletedMessage')
  //                           });
  //                         }
  //                         if (res.status === AppConstants.VIEW_EXCEPTION
  //                             || res.status === AppConstants.STATUS_SYSTEM_ERROR) {
  //                           this.lmErrorUtilService.handleError(Soho.Locale.translate('ListPersonalizationWasNotDeletedMessage'), Soho.Locale.translate('ListPersonalizationErrorMessage'));
  //                         }
  //                       })
  //             }
  //           }
  //       )
  // }

  sharingIsValid() {
    if (this.actorGroupSharing && this.model.actorGroup === '') {
      return false;
    }

    if (this.roleSharing && this.model.role === '') {
      return false;
    }

    if (this.roleGroupSharing && this.model.roleGroup === '') {
      return false;
    }

    return true;
  }

  onLplChangedEvent(lpl: string) {
    this.model.conditionString = lpl;
  }

  onBuildComputeCondition() {
    const url = this.listUrlInfo ? this.listUrlInfo.fieldSearchUrl : this.fieldSearchUrl;
    const personalizationUrl = this.listUrlInfo ? this.listUrlInfo.reportPersonalizationUrl : this.url;
    const includeAudit = this.listSpec?.busListSpec?.isAudit || this.model?.dataOption === 'audit';

    this.lmComputeBuilderService.openComputeBuilderDialog(this.model.businessClass, this.fieldLookUpUrl,
      url, personalizationUrl,  !!this.selectedField.name, false, includeAudit).pipe(
      takeUntil(this.unsubscribe$),
      takeWhile((result: LMComputeBuilderResult) => (result.lplQuery && result.lplQuery !== this.selectedField.name))
    ).subscribe((result: LMComputeBuilderResult) => {
      if (result.action === 'Append') {
        this.selectedField.name = `${this.selectedField.name} ${result.lplQuery}`;
      }

      // dialogResult is null if there's no this.modelField.value
      if (result.action === 'Ok' || result.action === 'Overwrite') {
        this.selectedField.name = result.lplQuery;
      }

      this.changeDetectionRef.detectChanges();
      this.onChange();
    });
  }

  private buildCubeInfo(): LMCubeReportInfo {
    const cubeInfo: LMCubeReportInfo = {};
    if (this.cubeColumnView) {
      cubeInfo.columnView = this.cubeColumnView;
    }

    this.cubeViewState = this.cubeDimensions.updateCubeState();

    if (this.cubeViewState.cubeOverrides.pivotView) {
      cubeInfo.pivotView = this.cubeViewState.cubeOverrides.pivotView;
    }

    if (this.cubeViewState.cubeOverrides.dimensionOverrides.dimensionsOverride) {
      cubeInfo.currentDims = this.cubeViewState.cubeOverrides.dimensionOverrides.dimensionsOverride.split(',');
    }

    if (this.cubeViewState.cubeOverrides.dimensionOverrides.suppressZeros !== undefined) {
      cubeInfo.suppressZeros = this.cubeViewState.cubeOverrides.dimensionOverrides.suppressZeros;
    }

    if (this.cubeViewState.cubeOverrides.dimensionOverrides.suppressCurPeriod !== undefined) {
      cubeInfo.suppressCurPeriod = this.cubeViewState.cubeOverrides.dimensionOverrides.suppressCurPeriod;
    }

    return cubeInfo;
  }

  onShowLabel(showLabel: boolean){
    this.showLabel = showLabel;
    const gridColumns: ListGridColumn[] = this.columnDataGridComponent.getColumns();
    const columnGroups: SohoDataGridColumnGroup[] = this.columnDataGridComponent.getColumnGroups();

    if(showLabel){
      this.showLabelText = Soho.Locale.translate('ShowLabel');
    } else {
      this.showLabelText = Soho.Locale.translate('ShowField');
    }

    if (gridColumns) {
      gridColumns
        .map(column => <ListGridColumn>column)
        .forEach((column: ListGridColumn) => {
          if (column.field === 'label') {
            column.hidden = !showLabel;
          } else if (column.field === 'field') {
            column.hidden = showLabel;
          }
        });
    }
    this.columnDataGridComponent.updateColumns(gridColumns, columnGroups);
    this.buildTotalFieldInfo();
    this.buildSortInfo();
    this.buildSubtotalByInfo();
  }

  private buildSortInfo() {
    this.sortByInfo = [];
    const hasDefaultSort = this.model.defaultSortColumn === undefined || this.model.defaultSortColumn === '' ? false : true;
    if (!hasDefaultSort && !this.isColumnarView) {
      const implicitSortInfo = this.buildImplicitSort();
      if (implicitSortInfo) {
        this.sortByInfo.push(implicitSortInfo);
      }
    }
    if (this.isColumnarView) {
      if (this.displayFields?.length > 0) {
        this.displayFields.filter(df => {
          if (df.type === 'Field') {
            return true;
          }
        }).forEach((bff, i) => {
          const sortInfo: LMSortInfo = {
            type: 'displayField',
            column: bff,
            sortOrder: bff.name,
            name: this.buildColumnIdentifier(bff)
          };

          this.sortByInfo.push(sortInfo);
        });
      }
    } else {
      if (this.displayFields?.length > 0) {
        this.displayFields.forEach(df => {
          if (df.sortOrder && this.setSpecs.hasOwnProperty(df.sortOrder)) {
            this.sortByInfo.push({
              type: 'displayField',
              column: df,
              sortOrder: df.sortOrder,
              name: this.buildColumnIdentifier(df)
            });
          }
        });
      }
    }

  }

  private buildImplicitSort(): LMSortInfo {
    let implicitSortInfo: LMSortInfo;
    if (this.isColumnarView) {
      // nothing
    } else {
      const keys: Array<string> = Object.keys(this.setSpecs);

      for (const key of keys) {
        if (this.setSpecs[key].isPrimary) {
          implicitSortInfo = {
            type: 'implicit',
            sortOrder: key,
            name: Soho.Locale.translate('BusinessClassDefaultSort') };
          return implicitSortInfo;
        }
      }
    }

    return implicitSortInfo;
  }
  private buildTotalFieldInfo() {
    this.columnTotalFieldInfo = [];

    this.displayFields.forEach(df => {
      if (df.canTotal) {
        this.columnTotalFieldInfo.push({
          type: 'displayField',
          column: df,
          fieldName: this.buildColumnIdentifier(df),
          totalType: df.totaling
        });
      }
    });
  }

  private buildSummaryTotalFieldInfo() {
    this.summaryTotalFieldInfo = [];
    if (this.summaryTotalFields?.length > 0) {
      this.summaryTotalFields.forEach(stFld => {
        this.summaryTotalFieldInfo.push({
          type: 'summary',
          fieldName: stFld.fieldId,
          summaryTotalFld: stFld,
          totalType: 'SUMMARY'
        });
      });
    }
  }

  private updateHasTotaling() {
    if (this.summaryTotalFields?.length > 0) {
      this.hasTotaling = true;
      return true;
    }
    let totalColumn;
    if (this.displayFields?.length > 0) {
      totalColumn = this.displayFields.find(df => {
        if (df.totaling === 'TOTAL' || df.totaling === 'PERCENT_OF_TOTAL' || df.totaling === 'RUNNING_TOTAL'){
          return true;
        }
      });
    }
    this.hasTotaling = totalColumn ? true : false;
  }

  private buildSubtotalByInfo() {
    this.subTotalByInfo = [];
    const defaultSort = this.displayFields.find(df => df.defaultSort);
    if (!defaultSort && this.setSpecs) {
      const keys: Array<string> = Object.keys(this.setSpecs);
      let implicitSetName: string;
      let implicitSet: LMSetSpec;

      for (const key of keys) {
        if (this.setSpecs[key].isPrimary) {
          implicitSetName = key;
          implicitSet = this.setSpecs[key];
          break;
        }
      }

      if (implicitSet) {
        const implicitSubTotalBy: Array<LMSubtotalOverride> = [];

        implicitSet.sortFields.forEach(sf => {
          if (sf.sortBreak) {
            implicitSubTotalBy.push(this.buildSubTotalBy(sf.name));
          }
        });

        if (implicitSubTotalBy.length > 0) {
          this.subTotalByInfo.push({
            type: 'implicit',
            sortOrder: implicitSetName,
            subTotalBy: implicitSubTotalBy,
            name: Soho.Locale.translate('BusinessClassDefaultSort'),
            disable: implicitSubTotalBy.filter(value => value.enabled).length < 2
          });
        }
      }
    }

    if (this.displayFields?.length > 0) {
      this.displayFields.forEach(df => {
        if (df.sortOrder && this.setSpecs.hasOwnProperty(df.sortOrder)) {
          const columnSet = this.setSpecs[df.sortOrder];
          const subTotalBy: Array<LMSubtotalOverride> = [];
          columnSet.sortFields.forEach(sf => {
            if (sf.sortBreak) {
              subTotalBy.push(this.buildSubTotalBy(sf.name, df));
            }
          });

          if (subTotalBy.length > 0) {
            this.subTotalByInfo.push({
              type: 'displayField',
              sortOrder: df.sortOrder,
              column: df,
              subTotalBy,
              name: this.buildColumnIdentifier(df),
              disable: subTotalBy.filter(value => value.enabled).length < 2
            });
          }
        }
      });
    }

    this.changeDetectionRef.detectChanges(); // wierd need this coming back from the add sort
  }


  private buildSubTotalBy(sortField: string, column?: LMPersonalizationColumn): LMSubtotalOverride {
    const overrideInfo = column ? column.subtotalBy : this.subtotalOverride;
    return this._buildSubTotalBy(sortField, overrideInfo);
  }

  private _buildSubTotalBy(sortField: string, overrideInfo: Array<LMSubtotalOverride>): LMSubtotalOverride {
    let info: LMSubtotalOverride;
    if (overrideInfo?.length > 0) {
      info = overrideInfo.find(stb => {
        if (stb.field === sortField) {
          return true;
        }
      });
      return info ? info : { enabled: false, field: sortField, pageBreak: false };
    } else {
      return { enabled: true, field: sortField, pageBreak: false };
    }
  }

  private updateSubtotalInfo() {
    if (this.subTotalByInfo?.length > 0) {
      this.subTotalByInfo.forEach(info => {
        if (info.type === 'displayField') {
          this.updateColumnSubtotalBy(info);
        } else if (info.type === 'implicit') {
          this.updateImplicitSubtotalBy(info);
        }
      });
    }
  }

  private isSortSubTotalOverridden(subTotalByInfo: LMSubTotalByInfo): boolean {
    let firstOverride: LMSubtotalOverride;
    if (subTotalByInfo.subTotalBy?.length > 0) {
      firstOverride = subTotalByInfo.subTotalBy.find(info => {
        if (!info.enabled || info.pageBreak) {
          return true;
        }
      });
    }
    return firstOverride ? true : false;
  }

  private updateColumnSubtotalBy(subTotalByInfo: LMSubTotalByInfo) {
    if (this.isSortSubTotalOverridden(subTotalByInfo)) {
      subTotalByInfo.column.subtotalBy = subTotalByInfo.subTotalBy;
    } else {
      subTotalByInfo.column.subtotalBy = []; // this means no overrides!
    }
  }

  private updateImplicitSubtotalBy(subTotalByInfo: LMSubTotalByInfo) {
    if (this.isSortSubTotalOverridden(subTotalByInfo)) {
      this.subtotalOverride = subTotalByInfo.subTotalBy;
    } else {
      this.subtotalOverride = [];// this means no overrides!
    }
  }

  private addColumnCount() {
    const countColumn: LMPersonalizationColumn = {
      index: Date.now(),
      type: 'Field',
      name: '(1)',
      label: Soho.Locale.translate('SummaryInstanceCountOperator'),
      placeholder: '',
      allowUpdate: false,
      canUpdate: false,
      sortOrder: '',
      totaling: 'TOTAL',
      canTotal: true,
      alerts: [],
      compute: true,
      added: true,
      defaultSort: false,
      sortDescending: false,
      isValid: true,
      validated: true,
    };

    this.displayFields.push(countColumn);

    if (this.columnDataGridComponent) {
      this.columnDataGridComponent.dataset = this.displayFields;
      this.columnDataGridComponent.rowStatus(this.displayFields.length - 1, 'new', 'column added'); // TODO transalation
    }
    this.buildTotalFieldInfo();
    this.updateHasTotaling();
  }

  onAddTotal(totalType: string) {
    if ('Summary' === totalType) {
      this.onAddSummaryTotal();
    } else if ('Column' === totalType) {
      this.onAddColumnTotal();
    }
  }

  onAddColumnTotal() {
    this.promptConfirmationMessage(Soho.Locale.translate('AddColumnCountConfirmation')).subscribe((response: any) => {
      if (response === ConfirmationDialogResult.CONFIRMATION_OK) {
        this.addColumnCount();
        this.changeDetectionRef.markForCheck();
      }
    });
  }

  onSummaryTotalFieldChange(summaryTotalField: LMSummaryTotalField) {
    summaryTotalField.updated = true;
  }

  onAddSummaryTotal() {
    const request: LMAddTotalRequest = {
      businessClass: this.model.businessClass,
      listName: this.model.listName,
      fieldValidationUrl: this.listUrlInfo ? this.listUrlInfo.reportPersonalizationUrl : this.url,
      fieldLookupUrl: this.listUrlInfo ? this.listUrlInfo.fieldSearchUrl : this.fieldSearchUrl
    };

    this.lmReportPersonalizationDialogService.openAddTotalDialog(request).subscribe(response => {
      if (response?.status === 'OK') {
        // need to also work with card list!
        if (!this.summaryTotalFields) {
          this.summaryTotalFields = new Array<LMSummaryTotalField>();
        }

        this.summaryTotalFields.push(response.summaryTotalField);

        this.buildSummaryTotalFieldInfo();
        this.updateHasTotaling();
        this.changeDetectionRef.detectChanges(); // wierd need this coming back from the add sort
      }
    });
  }

  onRemoveSummaryTotal(summaryTotalField: LMSummaryTotalField) {
    this.summaryTotalFields = this.summaryTotalFields.filter(stf => stf.index !== summaryTotalField.index);
    this.buildSummaryTotalFieldInfo();
    this.updateHasTotaling();
  }

  onColumnSubTotalByChanged(info: LMSubTotalByInfo) {
    const column = info.column;
    const subTotalBy = info.subTotalBy;
    if (column) {
      column.updated = true;
    }

    info.disable = subTotalBy.filter(override => override.enabled).length < 2;
  }

  onRemoveSort(column: LMPersonalizationColumn) {
    // need to also work with card list!
    const df = this.displayFields.find(col => col.index === column.index);

    if (df) {
      df.updated = true;
      df.sortOrder = '';
      df.sortDescending = false;

      if (df.defaultSort) {
        df.defaultSort = false;
        this.model.defaultSortColumn = undefined;
        this.model.sortDescending = false;
      }
    }

    if (this.selectedField?.index === column.index) {
      this.dropDown.selectValue('');
      this.selectedField.sortOrder = '';
      this.selectedField.sortDescending = false;
      this.onSortOrderChanged(this.selectedField);
    } else {
      this.buildSortInfo();
      this.buildSubtotalByInfo();
    }
  }

  onRemoveDefault(column: LMPersonalizationColumn) {
    // need to also work with card list!
    this.model.defaultSortColumn = '';
    this.model.sortDescending = false;
    const df = this.displayFields.find(col => col.index === column.index);

    if (df) {
      df.updated = true;
      df.defaultSort = false;
      df.sortDescending = false;
    }

    if (this.selectedField?.index === column.index) {
      this.selectedField.defaultSort = false;
      this.selectedField.sortDescending = false;
      this.onSortChange(this.selectedField);
    } else {
      this.onSortChange(column);
    }
  }

  onMakeDefault(column: LMPersonalizationColumn) {
    // need to also work with card list!
    this.model.defaultSortColumn = column.index.toString();
    this.model.sortDescending = false;
    const df = this.displayFields.find(col => col.index === column.index);

    if (df) {
      df.updated = true;
      df.defaultSort = true;
      df.sortDescending = false;
    }

    if (this.selectedField?.index === column.index) {
      this.selectedField.defaultSort = true;
      this.selectedField.sortDescending = false;
      this.onSortChange(this.selectedField);
    } else {
      this.selectedField.defaultSort = false;
      this.selectedField.sortDescending = false;
      this.onSortChange(column);
    }
  }

  onSortDescendingSwitched(column: LMPersonalizationColumn) {
    if (this.selectedField?.index === column.index) {
      this.selectedField.sortDescending = column.sortDescending;
    }

    this.onSortDescendingChange(column);
  }

  onAddSort() {
    const sortableColumns: Array<LMPersonalizationColumn> = [];
    this.displayFields.forEach(df => {
      if (df.type === 'Field' && !df.compute) {
        sortableColumns.push(df);
      }
    });

    this.lmReportPersonalizationDialogService.openAddSortDialog({ columns: sortableColumns, setSpecs: this.setSpecs }).subscribe(response => {
      if (response?.status === 'OK') {
        // need to also work with card list!
        const column = this.displayFields.find(col => col.index === response.column.index);

        if (column) {
          column.updated = true;
          column.sortOrder = response.sortOder;
          column.defaultSort = response.default;
          column.sortDescending = response.default ? response.descending : false;
          this.onSortChange(column);
        }

        if (this.selectedField?.index === column.index) {
          this.selectedField.sortOrder = response.sortOder;
          this.selectedField.defaultSort = response.default;
          this.selectedField.sortDescending = response.default ? response.descending : false;
          this.onSortChange(this.selectedField);
        } else {
          this.buildSortInfo();
          this.buildSubtotalByInfo();
          this.changeDetectionRef.detectChanges(); // wierd need this coming back from the add sort
        }
      }
    });
  }

  // this is used by the Total tab
  onTotalTypeChange(event: Event, column: LMPersonalizationColumn) {
    const totalType: DisplayFieldTotalType = event?.['data'];
    const df = this.displayFields.find(col => col.index === column.index);

    if (df) {
      df.updated = true;
      df.totaling = totalType;
    }

    if (this.selectedField?.index === column.index) {
      this.selectedField.totaling = totalType;
      this.onChange();
    } else {
      this.updateHasTotaling();
    }
  }

  // This is used by the Column tab
  onTotalTypeChanged(column: LMPersonalizationColumn) {
    this.onChange();
    this.buildTotalFieldInfo();
    this.updateHasTotaling();
  }

  private addTimeoutInlineAlert(id: string): void {
    const timeoutAlert = this.alerts.find((alert: SohoAlertDirective) => (alert.elementRef.nativeElement as Element).getAttribute('id') === id);
    timeoutAlert.addInlineMessage(Soho.Locale.translate('ListPersonalizationHTTPCallTimeout'), 'alert', true);
  }

  private buildColumnIdentifier(column: LMPersonalizationColumn): string {
    if (this.showLabel) {
      if (column.label?.trim().length > 0) {
        return column.label.trim();
      } else {
        const implicitLabel = column.name.replace(/([a-z])([A-Z])/g, '$1 $2');
        return implicitLabel.replace(/([A-Z])([A-Z][a-z])/g, '$1 $2');
      }
    } else {
      return column.name;
    }
  }

  private updatePdfFontOffsetOption(fontOffset) {

    if (fontOffset) {
      if (fontOffset === 0) {
        this.model.fontOffsetOption = 'default';
      } else if (fontOffset === -2) {
        this.model.fontOffsetOption = 'small';
      } else if (fontOffset === -3) {
        this.model.fontOffsetOption = 'smaller';
      } else if (fontOffset === -5) {
        this.model.fontOffsetOption = 'smallest';
      } else {
        this.model.fontOffsetOption ='custom';
      }
    } else {
      this.model.fontOffsetOption = 'default';
    }
  }

  private registerCustomRules(){
    const notEmpty: any = {
      check: (value: any, field: any, grid: any) => value.length > 0,
      id: 'custom',
      type: 'error',
      message: Soho.Locale.translate('Required')
    };

    Soho.Validation.rules['notEmpty'] = notEmpty;
  }
}

/*
Known Issues:
1.PDF bug with summary Total fields and pagebreak, seems like the pagebreak should be after all the summaryTotalFields
2.In the columns tab, change the default sort does not work if the first column.  First column is always set to default
3.% of Total shows ###, got last page and then back to first page, show what seems to be correct value. Wrong in PDF too. Thinking framework bug
 */
